<template>
  <div id="productorders">
    <v-card class="mx-auto" max-width="100%" outlined>
      <v-row no-gutters class="align-center">
        <v-card-title class="text-h4">
          {{ $i18n.t("headings.product") + " " + $i18n.t("headings.orders") }}
          <!-- <helper topic="classes" /> -->
        </v-card-title>
        <v-spacer />
        <!-- <div class="d-flex align-center" style="gap: 12px">
  <v-btn
    color="primary"
    :loading="backfilling"
    :disabled="backfilling"
    @click="backfillReportingOrderProducts"
  >
    Backfill order line items
  </v-btn>
  <v-btn
  color="primary"
  outlined
  :loading="backfilling"
  :disabled="backfilling"
  @click="catchUpReportingOrderProducts"
>
  Catch up (last 2 days)
</v-btn>

  <span v-if="backfilling || backfillStats.PAID.pages || backfillStats.PROCESSING.pages" class="text-caption">
    PAID: {{ backfillStats.PAID.orders }} orders / {{ backfillStats.PAID.rows }} rows
    (skipped {{ backfillStats.PAID.skipped }}) •
    PROCESSING: {{ backfillStats.PROCESSING.orders }} orders / {{ backfillStats.PROCESSING.rows }} rows
    (skipped {{ backfillStats.PROCESSING.skipped }})
  </span>

  <span v-if="backfillError" class="error--text text-caption">{{ backfillError }}</span>
</div> -->
        <div style="max-width: 175px" class="py-4 pr-4">
          <v-select
            v-model="orderEmailType"
            outlined
            placeholder="Send an email"
            dense
            clearable
            hide-details
            :items="[
              'INVOICE',
              'PAID',
              'PROCESSING',
              'ABANDONED CART 10% DISCOUNT OFFER',
              { divider: true },
              'PRODUCT OUTDATED',
            ]"
          ></v-select>
        </div>
        <!-- <v-btn class="mx-4" @click="deleteProductOrders" :disabled="offline">
          Archive Orders
        </v-btn> -->
        <v-btn
          v-show="
            isValidOwnerField(decodedRouteParamOwner) &&
            isAmplifyDataStoreId($route.params.teacherProfileId)
          "
          color="primary"
          class="mx-4"
          @click="createItem"
          :disabled="offline"
        >
          New Order
        </v-btn>
        <!-- <v-btn @click="updateAllOrderUpdatedStatuses">
          updateAllOrderUpdatedStatuses
        </v-btn> -->
      </v-row>

      <v-row class="px-4 mt-0 pb-4 align-center">
        <v-col cols="12" sm="6" md="8">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-checkbox
            v-model="searchPhysicalProductOrders"
            label="Has Physical Product"
            class="mt-0"
            style="margin-bottom: -24px"
          ></v-checkbox
        ></v-col>
        <v-col cols="6" sm="3" md="2">
          <v-checkbox
            v-model="searchQuestionProductOrders"
            label="Has Questions"
            class="mt-0"
            style="margin-bottom: -24px"
          ></v-checkbox
        ></v-col>
      </v-row>

      <v-row class="px-4 pb-4 align-center">
        <v-col cols="12" sm="4" md="3">
          <v-menu
            v-model="showStartDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="filterStartDate"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
                required
                :rules="formRules.required"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filterStartDate"
              no-title
              scrollable
              @input="showStartDateMenu = false"
            ></v-date-picker>
          </v-menu>

          <!-- <DateTimePicker
            v-model="filterStartDate"
            label="Start Date"
            required
          /> -->
        </v-col>

        <v-col cols="12" sm="4" md="3">
          <v-menu
            v-model="showEndDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="filterEndDate"
                label="To Date"
                prepend-icon="mdi-calendar"
                readonly
                required
                :rules="formRules.required"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filterEndDate"
              no-title
              scrollable
              @input="showEndDateMenu = false"
            ></v-date-picker>
          </v-menu>

          <!-- <DateTimePicker v-model="filterEndDate" label="End Date" required /> -->
        </v-col>

        <v-col cols="12" sm="4" md="3">
          <v-select
            v-model="filterStatuses"
            :items="orderStatuses"
            label="Order Status"
            multiple
            clearable
            chips
            small-chips
          ></v-select>
        </v-col>
      </v-row>

      <!-- <div v-if="backfillAnomalies.length" class="mt-3">
  <div class="text-subtitle-2 error--text">
    {{ backfillAnomalies.length }} order(s) flagged — investigate these:
  </div>
  <v-simple-table dense>
    <thead>
      <tr><th>Order</th><th>Anomalies</th><th>Record id</th></tr>
    </thead>
    <tbody>
      <tr v-for="a in backfillAnomalies" :key="a.orderRecordId">
        <td>{{ a.orderID || '—' }}</td>
        <td>{{ a.types.join(', ') }}</td>
        <td class="text-caption">{{ a.orderRecordId }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</div> -->

      <div class="px-4">
        <v-data-table
          :footer-props="{
            showFirstLastPage: true,
            itemsPerPageOptions: [5, 10, 15, 50, 100],
          }"
          :headers="headers"
          :items="filteredOrders"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          must-sort
          :custom-sort="customSort"
          show-group-by
          no-data-text="No Orders found"
          :loading="!syncedProductOrders"
          loading-text="Loading Orders..."
          show-expand
          single-expand
        >
          <!-- <template v-slot:[`item.orderID`]="{ item }">
            {{ `#${item.orderID}` }}
          </template> -->
          <template v-slot:[`item.orderDateTime`]="{ item }">
            {{ formatDate(item.orderDateTime) }}
          </template>
          <template v-slot:[`item.orderTotal`]="{ item }">
            {{ "R" + calculateOrderTotal(item).toFixed(2) }}
          </template>
          <template v-slot:[`item.orderProducts`]="{ item }">
            {{ item.orderProducts?.length > 0 ? item.orderProducts.length : 0 }}
          </template>
          <template v-slot:[`item.physical`]="{ item }">
            <v-icon
              v-if="syncedPOIDsWithPhysical?.some((poID) => poID === item.id)"
              >mdi-check</v-icon
            >
          </template>
          <template v-slot:[`item.questions`]="{ item }">
            <v-icon
              v-if="syncedPOIDsWithQuestions?.some((poID) => poID === item.id)"
              >mdi-check</v-icon
            >
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="getOrderDownloadLink(item)"
                  v-if="item.orderStatus === 'PAID'"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-link
                </v-icon>
                <div v-else style="display: inline-flex; width:24px; height:16px"></div>
              </template>
              <span>Download link</span>
            </v-tooltip>

            <v-tooltip>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="openNotesDialog(item)"
                  :disabled="offline"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-note-plus
                </v-icon>
              </template>
              <span>Add note</span>
            </v-tooltip>

            <v-btn
              v-if="
                typeof orderEmailType === 'string' && canSendOrderEmail(item)
              "
              icon
              small
              class="mr-2"
              :loading="sendingEmails[item.id]"
              :disabled="offline || sendingEmails[item.id]"
              @click="sendProductOrderEmail(item)"
            >
              <v-icon>mdi-email</v-icon>
            </v-btn>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="offline"
            >
              mdi-pencil
            </v-icon>
            <v-icon small @click="viewItem(item)"> mdi-eye </v-icon>
          </template>

          <template
            v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }"
          >
            <v-icon
              v-if="item.notes && item.notes.length > 0"
              @click="expand(!isExpanded)"
              color="primary"
            >
              {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="px-0">
              <v-data-table
                :headers="notesHeaders"
                :items="item.notes || []"
                hide-default-footer
                disable-pagination
                dense
                :sort-by="notesSortBy"
                :sort-desc="notesSortDesc"
                class="notes-table"
              >
                <template v-slot:[`item.timestamp`]="{ item }">
                  {{ formatDate(item.timestamp) }}
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="850px">
      <v-card class="overflow-x-hidden overflow-y-auto" max-height="90vh">
        <v-form ref="form" v-model="valid" @submit.prevent="save">
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <p>Date: {{ formatDate(editedItem.orderDateTime) }}</p>

                  <p>
                    {{
                      $i18n.t("headings.order") +
                      " " +
                      $i18n.t("otherText.id") +
                      ": " +
                      editedItem.orderID
                    }}
                  </p>

                  <p v-if="editedItem.coupon">
                    {{ $i18n.t("labels.coupon") + ": " }}
                    <span class="primary--text">
                      {{ editedItem.coupon.couponCode }}</span
                    >
                  </p>

                  <!-- <p
                    v-if="
                      editedIndex === -1 ||
                      (editedIndex > -1 &&
                        (editedItem.orderPaymentMethod !== 'EFT' ||
                          ((editedItem.orderStatus === 'PAID' ||
                            editedItem.orderStatus === 'CANCELLED') &&
                            !unsavedChanges)))
                    "
                  >
                    {{
                      $i18n.t("labels.status") + ": " + editedItem.orderStatus
                    }}
                  </p> -->
                  <!--disable if orderID or orderDateTime is null and orderStatus is PENDING-->
                  <v-select
                    v-model="editedItem.orderStatus"
                    :items="orderStatuses"
                    :label="`${$i18n.t('labels.status')}:`"
                    :disabled="
                      editedItem.orderID === null ||
                      editedItem.orderDateTime === null
                    "
                    :error-messages="
                      editedItem.orderID === null ||
                      editedItem.orderDateTime === null ||
                      editedItem.orderStatus === 'PENDING'
                        ? 'Order checkout required'
                        : ''
                    "
                  ></v-select>

                  <p>Payment Method: {{ editedItem.orderPaymentMethod }}</p>

                  <!-- <div
                    v-if="
                      editedIndex === -1 ||
                      editedItem.orderStatus !== 'PROCESSING'
                    "
                  >
                    <p>
                      {{ $i18n.t("headings.products") + ":" }}
                    </p>
                    <v-row style="gap: 8px" no-gutters>
                      <v-chip
                        v-for="(
                          orderProduct, opIndex
                        ) in editedItem.orderProducts"
                        :key="opIndex"
                        class="text-wrap py-1"
                        :to="`/app/products/${orderProduct.id}`"
                        style="height: fit-content"
                        >{{ orderProduct.title }}</v-chip
                      ></v-row
                    >
                  </div> -->
                  <v-autocomplete
                    v-model="editedItem.orderProducts"
                    @change="updateOrderProducts"
                    :items="productSelectArray"
                    item-text="title"
                    item-value="id"
                    :label="`${$i18n.t('headings.products')}*`"
                    return-object
                    required
                    :rules="formRules.products"
                    :loading="!syncedProducts || !syncedProductBundles"
                    chips
                    clearable
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" v-if="isEditable">
                  <div class="d-flex flex-row align-center" style="gap: 12px">
                    <v-text-field
                      v-model="couponCode"
                      :label="`${$i18n.t('labels.couponCode')}`"
                      :error-messages="couponVerifyErrors"
                      @keyup.enter="verifyCoupon"
                      @input="onCouponCodeInput"
                    ></v-text-field>

                    <v-icon
                      v-if="
                        editedItem.coupon &&
                        editedItem.coupon.couponCode === couponCode
                      "
                      color="primary"
                      >mdi-check</v-icon
                    >

                    <v-btn
                      color="primary"
                      v-else
                      :disabled="
                        verifyingCoupon || !couponCode || couponCode === ''
                      "
                      :loading="verifyingCoupon"
                      @click="verifyCoupon"
                      >{{ $i18n.t("actions.verify") }}</v-btn
                    >
                  </div>
                </v-col>

                <v-col cols="12">
                  <div v-if="editedItemProductsWithAddons.length > 0">
                    <v-card-title class="pt-0 pl-0" style="margin-left: -12px">
                      <span class="text-h5">Addons</span>
                    </v-card-title>

                    <div class="mt-4">
                      <div
                        v-for="(
                          product, pIndex
                        ) in editedItemProductsWithAddons"
                        :key="pIndex"
                      >
                        <v-select
                          v-if="getAvailableAddons(product.id).length > 0"
                          v-model="product.addons"
                          :items="getAvailableAddons(product.id)"
                          item-text="title"
                          return-object
                          multiple
                          :label="`Select Addons for ${product.title}`"
                          chips
                          :deletable-chips="isEditable"
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip
                              class="ma-1"
                              :input-value="true"
                              :close="isEditable"
                              @click:close="
                                removeAddonFromProduct(product, item)
                              "
                            >
                              {{ item.title }} ({{ item.type }}) - R{{
                                item.price.toFixed(2)
                              }}
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            {{ item.title }} ({{ item.type }}) - R{{
                              item.price.toFixed(2)
                            }}
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  v-show="editedItem.orderProducts?.length > 0"
                  style="font-size: 1.3rem; line-height: 1.5"
                >
                  <v-row no-gutters>
                    {{
                      $i18n.t("headings.products") +
                      " (" +
                      $i18n.t("labels.downloadable") +
                      ")"
                    }}: <v-spacer></v-spacer>

                    R{{ editedItemNonPhysicalProductsPrice.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters v-if="editedItemAddonsTotal > 0">
                    {{ $i18n.t("labels.addons") }}: <v-spacer></v-spacer> R
                    {{ editedItemAddonsTotal.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("headings.products") +
                      " (" +
                      $i18n.t("headings.shipping") +
                      ")"
                    }}: <v-spacer></v-spacer> R{{
                      editedItemPhysicalProductsPrice.toFixed(2)
                    }}
                  </v-row>

                  <v-row
                    no-gutters
                    v-show="editedItemPhysicalProducts?.length > 0"
                  >
                    {{ $i18n.t("headings.shippingFee") }}:
                    <v-spacer></v-spacer> R
                    {{ (130).toFixed(2) }}
                  </v-row>

                  <v-row no-gutters v-show="editedItem.coupon">
                    {{ $i18n.t("labels.coupon") }}: <v-spacer></v-spacer> -R{{
                      editedItemDiscountAmount.toFixed(2)
                    }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("labels.subTotal") +
                      " (" +
                      $i18n.t("labels.vatIncluded") +
                      ")"
                    }}: <v-spacer></v-spacer> R
                    {{ editedItemSubTotal.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("labels.total") +
                      " (" +
                      $i18n.t("labels.vatExcluded") +
                      ")"
                    }}: <v-spacer></v-spacer> R
                    {{ editedItemExclVAT.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters>
                    {{ $i18n.t("labels.vat") }} ( 15% ): <v-spacer></v-spacer> R
                    {{ editedItemTotalVat.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters>
                    {{ $i18n.t("labels.total") }}: <v-spacer></v-spacer> R
                    {{ editedItemSubTotal.toFixed(2) }}
                  </v-row>
                </v-col>

                <v-col
                  cols="12"
                  v-show="editedItem.orderPaymentMethod === 'EFT'"
                >
                  <v-card class="pa-3">
                    <span class="mb-0 text-subtitle-1"
                      ><strong>Bank Details:</strong></span
                    >
                    <p class="mb-0">Account holder: A Dempers</p>
                    <p class="mb-0">Account number: 1216434069</p>
                    <p class="mb-0">Account type: Current account</p>
                    <p class="mb-0">Bank name: Nedbank</p>
                    <p class="mb-0">Branch code: 198765</p>
                    <p class="mb-0">Reference: {{ editedItem.orderID }}</p>
                    <p class="mb-0">
                      Proof of payment: info@juffrouanri.com / +27 60 529 4868
                    </p>
                    <p class="mb-0">
                      Please email a bank-generated PDF proof of payment
                      (screenshots are not accepted), so that your order can be
                      verified and released.
                    </p>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-card-title class="pt-0 pl-0" style="margin-left: -12px">
                    <span class="text-h5">Products Breakdown</span>
                  </v-card-title>
                  <v-data-table
                    :headers="productsHeaders"
                    :items="editedItem.orderProducts || []"
                    hide-default-footer
                    disable-pagination
                    dense
                    sort-by="title"
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <template v-for="(product, productIndex) in items">
                          <tr :key="product.id">
                            <td>{{ product.title }}</td>
                            <td>{{ product.type }}</td>
                            <td>R{{ (product.price || 0).toFixed(2) }}</td>
                            <td>{{ discountedPrice(product) === (product.price || 0) ? '-' : `R${discountedPrice(product).toFixed(2)}` }}</td>
                            <td>{{ product.recommendedDiscount > 0 ? `${product.recommendedDiscount}%` : '-' }}</td>
                            <td>{{ product.discountPercentage > 0 || product.baseDiscountPercentage > 0 ? `${!product.isRecommendedDiscount ? product.discountPercentage : product.baseDiscountPercentage}%` : '-' }}</td>
                            <td>{{ editedItem.coupon ? (editedItem.coupon.discount.type === 'PERCENTAGE' ? `${editedItem.coupon.discount.value}%` : productIndex === 0 ? `R${editedItem.coupon.discount.value} OFF EVERYTHING` : '-') : '-' }}</td>
                          </tr>
                          <tr
                            v-for="addon in product.addons || []"
                            :key="
                              product.id + '-' + addon.title + '-' + addon.type
                            "
                            class="grey lighten-4"
                          >
                            <td class="pl-8">{{ addon.title }}</td>
                            <td>{{ addon.type }}</td>
                            <td>R{{ (addon.price || 0).toFixed(2) }}</td>
                            <td>
                              {{ discountedPrice(addon, true) === (addon.price || 0) ? '-' : `R${discountedPrice(addon, true).toFixed(2)}` }}
                            </td>
                            <td>{{ product.recommendedDiscount > 0 ? `${product.recommendedDiscount}%` : '-' }}</td>
                            <td>{{ product.discountPercentage > 0 || product.baseDiscountPercentage > 0 ? `${!product.isRecommendedDiscount ? product.discountPercentage : product.baseDiscountPercentage}%` : '-' }}</td>
                            <td>{{ editedItem.coupon?.discount?.type === 'PERCENTAGE' ? `${editedItem.coupon.discount.value}%` : '-' }}</td>
                          </tr>
                        </template>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <div v-if="editedItemProductsQuestions?.length > 0">
            <v-card-title class="pt-0">
              <span class="text-h5">Questions</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <div
                  v-for="(
                    productWithQuestions, productWithQuestionsIndex
                  ) in editedItemProductsQuestions"
                  :key="productWithQuestionsIndex"
                >
                  <span class="text-h6">{{ productWithQuestions.title }}</span>

                  <v-row>
                    <v-col cols="12">
                      <template
                        v-for="(
                          question, questionIndex
                        ) in productWithQuestions.questions"
                      >
                        <v-text-field
                          v-if="question.type === 'Text'"
                          :key="'text-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          @dblclick="copyPlaceholderToValue(question)"
                          :required="question.required"
                          :readonly="
                            editedIndex === -1 ||
                            !['DRAFT', 'PROCESSING'].includes(
                              editedItem.orderStatus,
                            )
                          "
                          :rules="question.required ? formRules.required : []"
                        ></v-text-field>
                        <v-textarea
                          v-if="question.type === 'Textarea'"
                          :key="'textarea-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          @dblclick="copyPlaceholderToValue(question)"
                          auto-grow
                          :required="question.required"
                          :readonly="
                            editedIndex === -1 ||
                            !['DRAFT', 'PROCESSING'].includes(
                              editedItem.orderStatus,
                            )
                          "
                          :rules="question.required ? formRules.required : []"
                        ></v-textarea>
                        <v-select
                          v-if="
                            question.type === 'Select' ||
                            question.type === 'Multi Select'
                          "
                          :key="'select-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :items="question.items"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          :multiple="question.type === 'Multi Select'"
                          :required="question.required"
                          :readonly="
                            editedIndex === -1 ||
                            !['DRAFT', 'PROCESSING'].includes(
                              editedItem.orderStatus,
                            )
                          "
                          :rules="question.required ? formRules.required : []"
                        ></v-select>
                        <v-radio-group
                          v-if="question.type === 'Radio'"
                          :key="'radio-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :readonly="
                            editedIndex === -1 ||
                            !['DRAFT', 'PROCESSING'].includes(
                              editedItem.orderStatus,
                            )
                          "
                          :rules="question.required ? formRules.required : []"
                        >
                          <v-radio
                            v-for="(item, itemIndex) in question.items"
                            :key="'item-' + itemIndex"
                            :label="item"
                            :value="item"
                          ></v-radio>
                        </v-radio-group>
                        <div
                          v-if="question.type === 'Checkbox'"
                          :key="'checkbox-container-' + questionIndex"
                        >
                          <span class="v-label">{{ question.label }}</span>
                          <template>
                            <v-checkbox
                              v-for="(item, itemIndex) in question.items"
                              :key="
                                'checkbox-' + questionIndex + '-' + itemIndex
                              "
                              v-model="question.value"
                              :value="item"
                              :label="item"
                              :readonly="
                                editedIndex === -1 ||
                                !['DRAFT', 'PROCESSING'].includes(
                                  editedItem.orderStatus,
                                )
                              "
                              :rules="
                                question.required ? formRules.required : []
                              "
                            ></v-checkbox>
                          </template>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>
          </div>

          <div v-if="editedItemPhysicalProducts?.length > 0">
            <v-card-title class="py-0" style="gap: 12px">
              <span class="text-h5">{{
                $i18n.t("headings.shippingInfo")
              }}</span>
              <v-spacer></v-spacer>
              <v-btn
                v-show="
                  (editedItem.orderStatus === 'PROCESSING' ||
                    editedItem.orderStatus === 'DRAFT') &&
                  isValidOwnerField(decodedRouteParamOwner) &&
                  isAmplifyDataStoreId($route.params.teacherProfileId)
                "
                color="primary"
                @click="fetchTeacherShippingDetails"
                :loading="gettingTeacherShippingDetails"
                :disabled="gettingTeacherShippingDetails || offline"
              >
                Fetch Shipping Details
              </v-btn>
            </v-card-title>

            <div
              v-show="noShippingDetailsFound && !gettingTeacherShippingDetails"
              class="px-4 pt-6"
            >
              <v-alert class="mb-0" type="warning">{{
                $i18n.t("products.noShippingDetailsFound")
              }}</v-alert>
            </div>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="shippingDetails.address1"
                      :label="`${$i18n.t('labels.address')} 1`"
                      :rules="formRules.address1"
                      required
                      :readonly="
                        editedIndex === -1 ||
                        editedItem.orderStatus !== 'PROCESSING'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="shippingDetails.address2"
                      :label="`${$i18n.t('labels.address')} 2`"
                      :readonly="
                        editedIndex === -1 ||
                        editedItem.orderStatus !== 'PROCESSING'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.city"
                      :label="$i18n.t('labels.city')"
                      :rules="formRules.city"
                      required
                      :readonly="
                        editedIndex === -1 ||
                        editedItem.orderStatus !== 'PROCESSING'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="shippingDetails.province"
                      :items="provinces"
                      :label="`${$i18n.t('labels.province')}*`"
                      :rules="formRules.province"
                      required
                      :readonly="
                        editedIndex === -1 ||
                        editedItem.orderStatus !== 'PROCESSING'
                      "
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.postalCode"
                      :label="$i18n.t('labels.postalCode')"
                      :rules="formRules.postalCode"
                      required
                      :readonly="
                        editedIndex === -1 ||
                        editedItem.orderStatus !== 'PROCESSING'
                      "
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.country"
                      readonly
                      :label="$i18n.t('labels.country')"
                      :rules="formRules.country"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.phoneNumber"
                      :label="
                        $i18n.t('labels.phone') + ' ' + $i18n.t('labels.number')
                      "
                      :rules="formRules.phoneNumber"
                      required
                      :readonly="
                        editedIndex === -1 ||
                        editedItem.orderStatus !== 'PROCESSING'
                      "
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  v-show="
                    isValidOwnerField(decodedRouteParamOwner) &&
                    isAmplifyDataStoreId($route.params.teacherProfileId) &&
                    (shippingChanged || savedShippingDetails)
                  "
                  no-gutters
                >
                  <div>
                    {{ $i18n.t("products.saveShipping") }}
                    <v-btn
                      color="green"
                      class="ml-3 white--text"
                      :disabled="
                        !shippingChanged ||
                        savingTeacherShippingDetails ||
                        offline
                      "
                      :loading="savingTeacherShippingDetails"
                      @click="saveTeacherShippingDetails"
                      >{{ $i18n.t("actions.yes") }}</v-btn
                    >
                  </div>

                  <div
                    v-if="savedShippingDetails && !savingTeacherShippingDetails"
                    class="ml-3 d-flex align-center"
                  >
                    <!-- {{ $i18n.t("actions.saved") + "!" }} -->
                    <v-icon color="success" class="slide-x-transition">
                      mdi-check-circle
                    </v-icon>
                  </div>
                </v-row>
              </v-container>
            </v-card-text>
          </div>

          <v-card-actions>
            <v-spacer v-show="editedIndex === -1"></v-spacer>
            <v-btn
              color="primary"
              @click="close"
              :disabled="savingProductOrder"
            >
              {{ $i18n.t("actions.close") }}
            </v-btn>
            <v-spacer v-show="editedIndex > -1"></v-spacer>
            <v-btn
              v-show="editedIndex > -1"
              :disabled="!valid || !unsavedChanges || savingProductOrder"
              :loading="savingProductOrder"
              color="primary"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createDialog" max-width="500px">
      <v-card class="overflow-x-hidden overflow-y-auto" max-height="90vh">
        <v-form ref="form" v-model="validCreate" @submit.prevent="save">
          <v-card-title>
            <span class="text-h5">Create Product Order</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <!-- createdAt : "2024-10-03T13:25:49.684Z" 
                id : "04fb13c7-22cc-4411-9b6e-e4bcdbac7bcb"
                orderDateTime : "2024-10-03T13:26:03.000Z"
                orderID : "20241003-152603"
                orderPayment : null
                orderPaymentMethod : "EFT"
                orderProducts : [{…}]
                orderShippingDetails : null
                orderStatus : "PAID"
                orderTotal : 95
                orderVAT : 12.39
                owner : "anridempers"
                teacherprofileID : "7d2b4902-ca79-4539-a27c-86bd80044b28" -->
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedItem.orderProducts"
                    @change="updateOrderProducts"
                    :items="productSelectArray"
                    item-text="title"
                    item-value="id"
                    :label="`${$i18n.t('headings.products')}*`"
                    return-object
                    required
                    :rules="formRules.products"
                    :loading="!syncedProducts || !syncedProductBundles"
                    chips
                    clearable
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <div v-if="editedItemProductsWithAddons.length > 0">
                    <v-card-title class="pt-0 pl-0" style="margin-left: -12px">
                      <span class="text-h5">Addons</span>
                    </v-card-title>

                    <div class="mt-4">
                      <div
                        v-for="(
                          product, pIndex
                        ) in editedItemProductsWithAddons"
                        :key="pIndex"
                      >
                        <v-select
                          v-if="getAvailableAddons(product.id).length > 0"
                          v-model="product.addons"
                          :items="getAvailableAddons(product.id)"
                          item-text="title"
                          return-object
                          multiple
                          :label="`Select Addons for ${product.title}`"
                          chips
                          deletable-chips
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip
                              class="ma-1"
                              :input-value="true"
                              close
                              @click:close="
                                removeAddonFromProduct(product, item)
                              "
                            >
                              {{ item.title }} ({{ item.type }}) - R{{
                                item.price.toFixed(2)
                              }}
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            {{ item.title }} ({{ item.type }}) - R{{
                              item.price.toFixed(2)
                            }}
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="editedItem.orderPaymentMethod"
                    :items="paymentMethods"
                    item-text="title"
                    item-value="value"
                    :label="`${$i18n.t('products.paymentMethod')}*`"
                    :rules="formRules.paymentMethod"
                    readonly
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <div class="d-flex flex-row align-center" style="gap: 12px">
                    <v-text-field
                      v-model="couponCode"
                      :label="`${$i18n.t('labels.couponCode')}`"
                      :error-messages="couponVerifyErrors"
                      @keyup.enter="verifyCoupon"
                      @input="onCouponCodeInput"
                    ></v-text-field>

                    <v-icon
                      v-if="
                        editedItem.coupon &&
                        editedItem.coupon.couponCode === couponCode
                      "
                      color="primary"
                      >mdi-check</v-icon
                    >

                    <v-btn
                      color="primary"
                      v-else
                      :disabled="
                        verifyingCoupon || !couponCode || couponCode === ''
                      "
                      :loading="verifyingCoupon"
                      @click="verifyCoupon"
                      >{{ $i18n.t("actions.verify") }}</v-btn
                    >
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  v-show="editedItem.orderProducts?.length > 0"
                  style="font-size: 1.3rem; line-height: 1.5"
                >
                  <v-row no-gutters>
                    {{
                      $i18n.t("headings.products") +
                      " (" +
                      $i18n.t("labels.downloadable") +
                      ")"
                    }}: <v-spacer></v-spacer>

                    R{{ editedItemNonPhysicalProductsPrice.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("headings.products") +
                      " (" +
                      $i18n.t("headings.shipping") +
                      ")"
                    }}: <v-spacer></v-spacer> R{{
                      editedItemPhysicalProductsPrice.toFixed(2)
                    }}
                  </v-row>

                  <v-row
                    no-gutters
                    v-show="editedItemPhysicalProducts?.length > 0"
                  >
                    {{ $i18n.t("headings.shippingFee") }}:
                    <v-spacer></v-spacer> R
                    {{ (130).toFixed(2) }}
                  </v-row>

                  <v-row no-gutters v-show="editedItem.coupon">
                    {{ $i18n.t("labels.coupon") }}: <v-spacer></v-spacer> -R{{
                      editedItemDiscountAmount.toFixed(2)
                    }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("labels.subTotal") +
                      " (" +
                      $i18n.t("labels.vatIncluded") +
                      ")"
                    }}: <v-spacer></v-spacer> R
                    {{ editedItemSubTotal.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{
                      $i18n.t("labels.total") +
                      " (" +
                      $i18n.t("labels.vatExcluded") +
                      ")"
                    }}: <v-spacer></v-spacer> R
                    {{ editedItemExclVAT.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{ $i18n.t("labels.vat") }} ( 15% ): <v-spacer></v-spacer> R
                    {{ editedItemTotalVat.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{ $i18n.t("labels.total") }}: <v-spacer></v-spacer> R
                    {{ editedItemSubTotal.toFixed(2) }}
                  </v-row>
                </v-col>
                <!-- <v-col cols="12" v-show="editedItem.orderPaymentMethod === 'EFT'">
                <v-card class="pa-3">
                  <span class="mb-0 text-subtitle-1"><strong>Bank Details:</strong></span>
                  <p class="mb-0">Account holder: A Dempers</p>
                  <p class="mb-0">Account number: 1216434069</p>
                  <p class="mb-0">Account type: Lopende rekening (Current account)</p>
                  <p class="mb-0">Bank name: Nedbank</p>
                  <p class="mb-0">Branch code: 198765</p>
                  <p class="mb-0">Reference: Your Name</p>
                  <p class="mb-0">Proof of payment: info@juffrouanri.com / +27 60 529 4868</p>
                    <p class="mb-0">
Please email a bank-generated PDF proof of payment (screenshots are not accepted), so that your order can be verified and released.
                    </p>
                </v-card>
              </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <div v-if="editedItemProductsQuestions?.length > 0">
            <v-card-title class="pt-0">
              <span class="text-h5">Questions</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <div
                  v-for="(
                    productWithQuestions, productWithQuestionsIndex
                  ) in editedItemProductsQuestions"
                  :key="productWithQuestionsIndex"
                >
                  <span class="text-h6">{{ productWithQuestions.title }}</span>

                  <v-row>
                    <v-col cols="12">
                      <template
                        v-for="(
                          question, questionIndex
                        ) in productWithQuestions.questions"
                      >
                        <v-text-field
                          v-if="question.type === 'Text'"
                          :key="'text-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          @dblclick="copyPlaceholderToValue(question)"
                          :required="question.required"
                          :rules="question.required ? formRules.required : []"
                        ></v-text-field>
                        <v-textarea
                          v-if="question.type === 'Textarea'"
                          :key="'textarea-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          @dblclick="copyPlaceholderToValue(question)"
                          auto-grow
                          :required="question.required"
                          :rules="question.required ? formRules.required : []"
                        ></v-textarea>
                        <v-select
                          v-if="
                            question.type === 'Select' ||
                            question.type === 'Multi Select'
                          "
                          :key="'select-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :items="question.items"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          :multiple="question.type === 'Multi Select'"
                          :required="question.required"
                          :rules="question.required ? formRules.required : []"
                        ></v-select>
                        <v-radio-group
                          v-if="question.type === 'Radio'"
                          :key="'radio-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :rules="question.required ? formRules.required : []"
                        >
                          <v-radio
                            v-for="(item, itemIndex) in question.items"
                            :key="'item-' + itemIndex"
                            :label="item"
                            :value="item"
                          ></v-radio>
                        </v-radio-group>
                        <div
                          v-if="question.type === 'Checkbox'"
                          :key="'checkbox-container-' + questionIndex"
                        >
                          <span class="v-label">{{ question.label }}</span>
                          <template>
                            <v-checkbox
                              v-for="(item, itemIndex) in question.items"
                              :key="
                                'checkbox-' + questionIndex + '-' + itemIndex
                              "
                              v-model="question.value"
                              :value="item"
                              :label="item"
                              :rules="
                                question.required ? formRules.required : []
                              "
                            ></v-checkbox>
                          </template>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>
          </div>

          <div v-if="editedItemPhysicalProducts?.length > 0">
            <v-card-title class="py-0" style="gap: 12px">
              <span class="text-h5">{{
                $i18n.t("headings.shippingInfo")
              }}</span>
              <v-spacer></v-spacer>
              <v-btn
                v-show="
                  isValidOwnerField(decodedRouteParamOwner) &&
                  isAmplifyDataStoreId($route.params.teacherProfileId)
                "
                color="primary"
                @click="fetchTeacherShippingDetails"
                :loading="gettingTeacherShippingDetails"
                :disabled="gettingTeacherShippingDetails || offline"
              >
                Fetch Shipping Details
              </v-btn>
            </v-card-title>

            <div
              v-show="noShippingDetailsFound && !gettingTeacherShippingDetails"
              class="px-4 pt-6"
            >
              <v-alert class="mb-0" type="warning">{{
                $i18n.t("products.noShippingDetailsFound")
              }}</v-alert>
            </div>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="shippingDetails.address1"
                      :label="`${$i18n.t('labels.address')} 1`"
                      :rules="formRules.address1"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="shippingDetails.address2"
                      :label="`${$i18n.t('labels.address')} 2`"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.city"
                      :label="$i18n.t('labels.city')"
                      :rules="formRules.city"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="shippingDetails.province"
                      :items="provinces"
                      :label="`${$i18n.t('labels.province')}*`"
                      :rules="formRules.province"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.postalCode"
                      :label="$i18n.t('labels.postalCode')"
                      :rules="formRules.postalCode"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.country"
                      readonly
                      :label="$i18n.t('labels.country')"
                      :rules="formRules.country"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.phoneNumber"
                      :label="
                        $i18n.t('labels.phone') + ' ' + $i18n.t('labels.number')
                      "
                      :rules="formRules.phoneNumber"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  v-show="shippingChanged || savedShippingDetails"
                  no-gutters
                >
                  <div>
                    {{ $i18n.t("products.saveShipping") }}
                    <v-btn
                      color="green"
                      class="ml-3 white--text"
                      :disabled="
                        !shippingChanged ||
                        savingTeacherShippingDetails ||
                        offline
                      "
                      :loading="savingTeacherShippingDetails"
                      @click="saveTeacherShippingDetails"
                      >{{ $i18n.t("actions.yes") }}</v-btn
                    >
                  </div>

                  <div
                    v-if="savedShippingDetails && !savingTeacherShippingDetails"
                    class="ml-3 d-flex align-center"
                  >
                    <!-- {{ $i18n.t("actions.saved") + "!" }} -->
                    <v-icon color="success" class="slide-x-transition">
                      mdi-check-circle
                    </v-icon>
                  </div>
                </v-row>
              </v-container>
            </v-card-text>
          </div>

          <v-card-actions>
            <v-btn
              color="primary"
              @click="close"
              :disabled="savingProductOrder"
            >
              {{ $i18n.t("actions.close") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!validCreate || savingProductOrder"
              :loading="savingProductOrder"
              color="primary"
              @click="save"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="notesDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >Add Note to Order {{ editedItem?.orderID }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="newNote"
            label="Note"
            outlined
            auto-grow
            :rules="[(v) => !!v || 'Note is required']"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="notesDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!newNote || offline"
            @click="saveNote"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
    
    <v-snackbar
      v-model="copiedDownloadLinkSnackbar"
      min-width="auto"
      top
      elevation="10"
      timeout="2000"
      rounded="pill"
      color="secondary"
    >
      <div class="text-center">Download link copied!</div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
// import Helper from "@/components/global-components/Helper.vue";
import {
  // DataStore, SortDirection, Predicates,
  API,
  Auth,
} from "aws-amplify";
import AWS from "aws-sdk";
// import DateTimePicker from "@/components/global-components/DateTimePicker.vue";
// import {
//   TeacherProductsOrder,
//   Product,
//   ProductBundle,
//   Secret,
//   ArchivedTeacherProductsOrder,
//   Coupon,
//   Announcement,
// } from "@/models";
// import store from "@/store";
// import { reconfigureDatastore } from "@/plugins/datastore/config.js";

import {
  listTeacherProductsOrders,
  teacherProductsOrdersByTeacherprofileID,
  getTeacherProductsOrder,
  listProducts,
  listProductBundles,
  listSecrets,
  teacherProductsOrdersByCreatedAtMonth,
  teacherProductsOrdersByUpdatedAtMonth,
  teacherProductsOrdersByOrderStatus,
} from "@/graphql/queries";
import {
  createTeacherProductsOrder,
  updateTeacherProductsOrder,
  deleteTeacherProductsOrder,
  createArchivedTeacherProductsOrder,
  createAnnouncement,
  // updateTeacherProductsOrder as updateArchived,
  createCoupon, // Alias if needed, but not used
} from "@/graphql/mutations";
import {
  onCreateTeacherProductsOrder,
  onUpdateTeacherProductsOrder,
  onDeleteTeacherProductsOrder,
  onCreateProduct,
  onUpdateProduct,
  onDeleteProduct,
  onCreateProductBundle,
  onUpdateProductBundle,
  onDeleteProductBundle,
  onCreateSecret,
  onUpdateSecret,
  onDeleteSecret,
} from "@/graphql/subscriptions";
import { buildTrackingDataLayerFields } from "@/core/utils/adMeta";

export default {
  name: "ProductOrders",
  components: {
    // Helper,
    // DateTimePicker,
  },
  data: () => ({
    initiallyLoaded: false,
    gettingTeacherShippingDetails: false,
    savingTeacherShippingDetails: false,
    savedShippingDetails: false,
    noShippingDetailsFound: false,
    dialog: false,
    createDialog: false,

    sortBy: "orderDateTime",
    sortDesc: true,
    headers: [],

    backfilling: false,
    backfillError: null,
    backfillStats: {
      PAID: { orders: 0, skipped: 0, rows: 0, pages: 0 },
      PROCESSING: { orders: 0, skipped: 0, rows: 0, pages: 0 },
    },    
    backfillAnomalies: [], // [{ orderRecordId, orderID, types }]

    notesSortBy: "timestamp",
    notesSortDesc: true,
    notesHeaders: [
      {
        text: "Timestamp",
        value: "timestamp",
        width: "140px",
        sortable: false,
      },
      { text: "Username", value: "username", width: "120px", sortable: false },
      { text: "Note", value: "note", sortable: false },
    ],

    productsHeaders: [
      { text: "Title" },
      { text: "Addon", sortable: false },
      { text: "Price", sortable: false },
      {
        text: "Discounted Price",
        sortable: false,
      },
      {
        text: "Recommended Discount",
        sortable: false,
      },
      { text: "Product Discount", sortable: false },
      {
        text: "Coupon Discount",
        sortable: false,
      },
    ],

    search: "",
    searchQuestionProductOrders: false,
    searchPhysicalProductOrders: false,

    filterStartDate: new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0], // 1 week ago
    filterEndDate: new Date().toISOString().split("T")[0],
    filterStatuses: ["PROCESSING", "PAID"],
    showStartDateMenu: false,
    showEndDateMenu: false,
    debouncedLoadOrders: null,

    editedIndex: -1,
    valid: false,
    validCreate: false,
    savingProductOrder: false,

    couponCode: "",
    verifyingCoupon: false,
    couponVerifyErrors: [],
    // validCoupon: null,

    orderEmailType: null,
    sentOrderResponse: "",
    sendingEmails: {}, // Tracks loading per order ID
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",

    copiedDownloadLinkSnackbar: false,

    notesDialog: false,
    newNote: "",

    editedItem: {
      orderDateTime: "",
      orderID: "",
      orderPayment: null,
      orderPaymentMethod: "",
      orderProducts: [],
      orderShippingDetails: null,
      orderStatus: "",
      orderTotal: 0,
      orderVAT: 0,
      coupon: null,
      owner: "",
      teacherprofileID: "",
    },
    defaultItem: {
      orderDateTime: "",
      orderID: "",
      orderPayment: null,
      orderPaymentMethod: "",
      orderProducts: [],
      orderShippingDetails: null,
      orderStatus: "",
      orderTotal: 0,
      orderVAT: 0,
      coupon: null,
      owner: "",
      teacherprofileID: "",
    },

    syncedShippingDetails: null,
    shippingDetails: {
      address1: "",
      address2: "",
      city: "",
      province: "",
      postalCode: "",
      country: "South Africa",
      phoneNumber: "",
    },
    defaultShippingDetails: {
      address1: "",
      address2: "",
      city: "",
      province: "",
      postalCode: "",
      country: "South Africa",
      phoneNumber: "",
    },

    // productsSubscription: null,
    syncedProductModels: [],
    productModels: [],
    syncedProducts: false,

    syncedSecretArray: [],
    secretSubscriptionSynced: false,

    syncedProductBundleModels: [],
    productBundleModels: [],
    syncedProductBundles: false,

    checkedRouteActions: false,

    // productOrdersSubscription: null,
    syncedProductOrders: false,
    syncedProductOrderModels: [],
    syncedPOIDsWithPhysical: [],
    syncedPOIDsWithQuestions: [],
    productOrderModels: [],

    productOrdersSubCreate: null,
    productOrdersSubUpdate: null,
    productOrdersSubDelete: null,
    productsSubCreate: null,
    productsSubUpdate: null,
    productsSubDelete: null,
    productBundlesSubCreate: null,
    productBundlesSubUpdate: null,
    productBundlesSubDelete: null,
    secretsSubCreate: null,
    secretsSubUpdate: null,
    secretsSubDelete: null,

    orderStatuses: ["PENDING", "PROCESSING", "PAID", "CANCELLED", "DRAFT"],

    paymentMethods: [
      { title: "EFT", value: "EFT" },
      { title: "Free", value: "Free" },
      { title: "Card Payment", value: "Payfast" },
    ],

    provinces: [
      "Eastern Cape",
      "Free State",
      "Gauteng",
      "KwaZulu-Natal",
      "Limpopo",
      "Mpumalanga",
      "Northern Cape",
      "North West",
      "Western Cape",
    ],

    formRules: {
      required: [(v) => !!v || "This field is required"],
      paymentMethod: [(v) => !!v || "a Payment Method is required"],
      products: [(v) => (!!v && v.length > 0) || "Products are required"],
      address1: [(v) => !!v || "Address is required"],
      city: [(v) => !!v || "City is required"],
      province: [(v) => !!v || "Province is required"],
      postalCode: [(v) => !!v || "Postal code is required"],
      country: [(v) => !!v || "Country is required"],
      phoneNumber: [
        (v) => !!v || "Phone number is required",
        (v) =>
          /^(?:\+27|0)\s?\d{2}\s?\d{3}\s?\d{4}$/.test(v) ||
          "Invalid South African phone number",
      ],
    },
  }),

  computed: {
    ...mapState({
      offline: (state) => !state.isOnline,
      userSignedIn: (state) => state.userSignedIn,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
      datastoreReady: (state) => state.datastoreReady,
      startedDatastoreSync: (state) => state.startedDatastoreSync,
    }),

    authMode() {
      return this.userSignedIn ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM";
    },

    editedItemProductsWithAddons() {
      return (
        this.editedItem.orderProducts?.filter(
          (product) => this.getAvailableAddons(product.id).length > 0,
        ) || []
      );
    },

    isEditable() {
      return (
        this.editedIndex === -1 ||
        ["DRAFT", "PROCESSING"].includes(this.editedItem.orderStatus)
      );
    },

    decodedRouteParamOwner() {
      return decodeURIComponent(this.$route.params.owner || "");
    },

    productSelectArray() {
      //sort via title
      return [...this.productModels, ...this.productBundleModels].sort(
        (a, b) => {
          if (!a || !b) return 0;
          return (a.title || "").localeCompare(b.title || "");
        },
      );
    },

    filteredOrders() {
      let orders = [...this.productOrderModels];

      // Search filter (adjust fields if you search more)
      if (this.search) {
        const lowerCaseSearch = this.search.toLowerCase();
        orders = orders.filter((order) => {
          const orderStr = `${order.orderID} ${order.owner} ${
            order.orderStatus
          } ${order.orderPaymentMethod} ${
            order.orderProducts?.map((p) => p.id || "").join(" ") || ""
          }`.toLowerCase();
          if (orderStr.includes(lowerCaseSearch)) {
            return true;
          }
        });
      }

      // Physical & Questions checkboxes
      if (this.searchPhysicalProductOrders) {
        orders = orders.filter((order) =>
          this.syncedPOIDsWithPhysical.includes(order.id),
        );
      }
      if (this.searchQuestionProductOrders) {
        orders = orders.filter((order) =>
          this.syncedPOIDsWithQuestions.includes(order.id),
        );
      }

      // const hasCustomFilter =
      //   this.filterStartDate ||
      //   this.filterEndDate ||
      //   this.filterStatuses.length > 0;

      const startDate = this.filterStartDate;

      const nextEndDay = new Date(this.filterEndDate);
      nextEndDay.setDate(nextEndDay.getDate() + 1);

      const endDate = nextEndDay.toISOString().split("T")[0];

      // console.log("Filtering orders with:", {
      //   filterStartDate: this.filterStartDate,
      //   filterEndDate: this.filterEndDate,
      //   startDate,
      //   endDate,
      //   filterStatuses: this.filterStatuses,
      // });

      // if (hasCustomFilter) {
      // User-defined filters
      orders = orders.filter((order) => {
        // Status
        if (
          // order.orderStatus === "QUOTING" ||
          this.filterStatuses.length > 0 &&
          !this.filterStatuses.includes(order.orderStatus)
        ) {
          return false;
        }
        // Date range
        const orderUpdatedAt = order.updatedAt.split("T")[0];

        if (startDate) {
          if (orderUpdatedAt < startDate) return false;
        }
        if (endDate) {
          if (orderUpdatedAt > endDate) return false;
        }
        return true;
      });
      // }
      //  else {
      //   // Default view: last 24 hours OR PROCESSING in last month
      //   const lastDayStart = new Date(Date.now() - 24 * 60 * 60 * 1000);
      //   const lastMonthStart = new Date();
      //   lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);

      //   orders = orders.filter((order) => {
      //     const orderDate = new Date(order.orderDateTime);
      //     const isLastDay = orderDate >= lastDayStart;
      //     const isProcessingLastMonth =
      //       order.orderStatus === "PROCESSING" &&
      //       new Date(order.createdAt) >= lastMonthStart;
      //     return isLastDay || isProcessingLastMonth;
      //   });
      // }

      return orders;
    },

    nonPendingOrders() {
      return (
        this.productOrderModels?.filter((order) => {
          const notPending =
            // order.orderStatus !== "PENDING" &&
            order.orderStatus !== "QUOTING";

          const physicalOrNot = this.searchPhysicalProductOrders
            ? order.orderProducts?.some((product) => product.physical === true)
            : true;
          const questionsOrNot = this.searchQuestionProductOrders
            ? order.orderProducts?.some(
                (product) =>
                  Array.isArray(product.questions) &&
                  product.questions.length > 0,
              )
            : true;

          return notPending && physicalOrNot && questionsOrNot;
        }) || []
      );
    },

    formTitle() {
      return this.editedIndex === -1
        ? "View Product Order"
        : "Edit Product Order";
    },

    unsavedChanges() {
      const productShippingChanged =
        this.editedItemPhysicalProducts?.length > 0
          ? JSON.stringify(this.editedItem.orderShippingDetails) !==
            JSON.stringify(this.shippingDetails)
          : false;

      return (
        JSON.stringify(
          _.find(this.syncedProductOrderModels, { id: this.editedItem.id }),
        ) !== JSON.stringify(this.editedItem) || productShippingChanged
      );
    },

    shippingChanged() {
      if (this.validCreate || this.valid) {
        const unchanged =
          JSON.stringify(this.syncedShippingDetails) ===
          JSON.stringify(this.shippingDetails);

        return unchanged ? false : true;
      } else {
        return false;
      }
    },

    editedItemPhysicalProducts() {
      return (
        this.editedItem.orderProducts?.filter(
          (product) => product.physical === true,
        ) || []
      );
    },

    editedItemProductsQuestions() {
      return (
        this.editedItem.orderProducts?.filter(
          (product) =>
            Array.isArray(product.questions) && product.questions.length > 0,
        ) || []
      );
    },

    editedItemPhysicalProductsPrice() {
      if (this.editedItemPhysicalProducts.length === 0) return 0;

      let price = 0;

      for (let product of this.editedItemPhysicalProducts) {
        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    editedItemNonPhysicalProductsPrice() {
      if (
        !this.editedItem.orderProducts ||
        this.editedItem.orderProducts.length === 0
      )
        return 0;

      let price = 0;

      for (let product of this.editedItem.orderProducts) {
        if (product.physical === true) continue;

        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    editedItemProductsPriceWithCoupon() {
      if (
        !this.editedItem.orderProducts ||
        this.editedItem.orderProducts.length === 0
      )
        return 0;

      let price = 0;

      for (let product of this.editedItem.orderProducts) {
        if (product.physical === true) continue;

        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const coupon = this.editedItem.coupon;
      if (coupon) {
        const percentageType = coupon.discount.type === "PERCENTAGE";

        price = percentageType
          ? price - price * (coupon.discount.value / 100)
          : price - coupon.discount.value;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    editedItemAddonsTotal() {
      let total = 0;
      if (!this.editedItem.orderProducts) return total;
      for (let product of this.editedItem.orderProducts) {
        if (!product.addons || !Array.isArray(product.addons)) continue;
        for (let addon of product.addons) {
          total += addon.price || 0;
        }
      }
      return total;
    },

    editedItemDiscountableTotal() {
      return (
        this.editedItemNonPhysicalProductsPrice +
        this.editedItemPhysicalProductsPrice +
        this.editedItemAddonsTotal
      );
    },

    editedItemDiscountedTotal() {
      let price = this.editedItemDiscountableTotal;
      // console.log("editedItemDiscountableTotal", price);
      // console.log("editedItem.coupon", this.editedItem.coupon);
      if (this.editedItem.coupon) {
        const discount = this.editedItem.coupon.discount;
        if (discount.type === "PERCENTAGE") {
          price *= 1 - discount.value / 100;
        } else {
          price -= discount.value;
          if (price < 0) price = 0;
        }
      }
      return price;
    },

    editedItemDiscountAmount() {
      return this.editedItemDiscountableTotal - this.editedItemDiscountedTotal;
    },

    editedItemSubTotal() {
      let subTotal = this.editedItemDiscountedTotal;
      if (this.editedItemPhysicalProducts.length > 0) subTotal += 130;
      return subTotal;
    },

    editedItemExclVAT() {
      return this.editedItemSubTotal
        ? Number.parseFloat(this.editedItemSubTotal / (1 + 0.15))
        : 0;
    },

    editedItemTotalVat() {
      return this.editedItemSubTotal
        ? Number.parseFloat(
            (this.editedItemSubTotal / (1 + 0.15) - this.editedItemSubTotal) *
              -1,
          )
        : 0;
    },

    // Sum of all lines after product-level discounts, before coupon.
    // Used to prorate fixed-amount coupons per line.
    preCouponLinesTotal() {
      let total = 0;
      for (const product of this.editedItem.orderProducts || []) {
        total += this.preCouponPrice(product);
        for (const addon of product.addons || []) {
          total += this.preCouponPrice(addon, true);
        }
      }
      return total;
    },
  },

  async mounted() {
    try {
      this.debouncedLoadOrders = _.debounce(this.loadOrders, 800);

      // store.commit("changeDatastorePredicates", [
      //   {
      //     model: "TeacherProductsOrder",
      //     predicate: "Admin",
      //   },
      //   {
      //     model: "Product",
      //     predicate: "Admin",
      //   },
      //   {
      //     model: "ProductBundle",
      //     predicate: "Admin",
      //   },
      //   {
      //     model: "Secret",
      //     predicate: "Admin",
      //   },
      // ]);

      // if (!this.startedDatastoreSync || this.datastoreReady) {
      //   reconfigureDatastore();
      // }

      // this.functions wont work in data because it this.something refers to something else withing data and not for example a method.
      this.headers = [
        { text: "Notes", value: "data-table-expand", groupable: false },
        { text: "Order #", value: "orderID", groupable: false },
        { text: "Date", value: "orderDateTime", groupable: false },
        { text: "User", value: "owner" },
        { text: "Status", value: "orderStatus" },
        { text: "Payment Method", value: "orderPaymentMethod" },
        { text: "Total", value: "orderTotal", groupable: false },
        { text: "Products Count", value: "orderProducts", groupable: false },
        {
          text: "Physical",
          value: "physical",
          groupable: false,
        },
        {
          text: "Questions",
          value: "questions",
          groupable: false,
        },
        {
          text: this.$i18n.t("labels.actions"),
          value: "actions",
          sortable: false,
          groupable: false,
        },
      ];

      // if (!this.changingDatastoreConfig) {
      this.syncProductOrders();
      this.syncProducts();
      this.syncProductBundles();
      this.syncSecrets();
      // }
    } catch (error) {
      console.log(error);
    } finally {
      if (!this.initiallyLoaded) {
        this.initiallyLoaded = true;
      }
    }
  },

  watch: {
    filterStartDate(val) {
      if (val) {
        this.debouncedLoadOrders();
      }
    },

    filterEndDate(val) {
      if (val) {
        this.debouncedLoadOrders();
      }
    },

    filterStatuses: {
      handler() {
        this.debouncedLoadOrders();
      },
      deep: true,
    },

    // changingDatastoreConfig: {
    //   async handler(newVal, oldVal) {
    //     // console.log("watch changingDatastoreConfig", newVal, oldVal);

    //     if (newVal === true) {
    //       return;
    //     }

    //     if (newVal === false) {
    //       this.syncProductOrders();
    //       this.syncProducts();
    //       this.syncProductBundles();
    //       this.syncSecrets();
    //     }
    //   },
    // },

    dialog(val) {
      val || this.close();
    },

    createDialog(val) {
      val || this.close();
    },

    "$route.params": {
      handler(newVal, oldVal) {
        // console.log("newVal", newVal);
        // console.log("oldVal", oldVal);
        const newValExists =
          typeof newVal === "object" &&
          (newVal.orderId || newVal.teacherProfileId || newVal.owner);

        if (newValExists) {
          if (
            newVal.owner &&
            newVal.teacherProfileId &&
            (!this.isAmplifyDataStoreId(newVal.teacherProfileId) ||
              !this.isValidOwnerField(newVal.owner))
          ) {
            this.$router.push({
              path: "/admin/productorders",
            });
          } else if (
            this.syncedProductOrders &&
            this.syncedProductOrderModels.length > 0
          ) {
            if (typeof newVal.orderId === "string") {
              const order = _.find(this.syncedProductOrderModels, {
                orderID: newVal.orderId,
              });
              if (order) {
                this.viewItem(order);
              }
            } else if (this.isAmplifyDataStoreId(newVal.teacherProfileId)) {
              this.productOrderModels = _.filter(
                this.syncedProductOrderModels,
                (item) =>
                  item.teacherprofileID === this.$route.params.teacherProfileId,
              );

              if (
                this.isValidOwnerField(newVal.owner) &&
                typeof newVal.action === "string" &&
                newVal.action === "new"
              ) {
                this.createItem();
              }
            }
            //2 arrays logic ---------------------------------------
            // else {
            //   this.productOrderModels = _.cloneDeep(
            //     this.syncedProductOrderModels
            //   );
            // }
            //2 arrays logic - END ---------------------------------
          }
          //  else if (
          //         this.isAmplifyDataStoreId(this.$route.params.teacherProfileId)
          //       ) {
          //         this.productOrderModels = _.filter(
          //           items,
          //           (item) =>
          //             item.teacherprofileID ===
          //             this.$route.params.teacherProfileId
          //         );
          //       } else {
          //         this.productOrderModels = _.cloneDeep(items);
          //       }
        } else if (!newValExists && typeof oldVal === "object") {
          this.productOrderModels = _.cloneDeep(this.syncedProductOrderModels);
        }
      },
      immediate: true,
    },

    // syncedProductOrderModels: {
    //   handler(val) {
    //     if (val?.length > 0) {
    //       if (typeof this.$route.params.orderId === "string") {
    //         const order = _.find(val, { orderID: this.$route.params.orderId });
    //         if (order) {
    //           this.viewItem(order);
    //         }
    //       } else if (
    //         typeof this.$route.params.action === "string" &&
    //         this.$route.params.action === "new"
    //       ) {
    //         this.createItem();
    //       }
    //     }
    //   },
    //   immediate: true,
    // },
  },

  methods: {
    getOrderDownloadLink(order) {

// const baseURL = "https://develop.d1n6idc0yuwrru.amplifyapp.com"; //staging
const baseURL = "https://www.juffrouanri.com"; //live

const link = `${baseURL}/product-content-downloader/${order.id}/${new Date(order.orderDateTime).getTime()}`;

      // Use the Web Share API to share a message, image, and URL
      if (navigator.share) {
        navigator
          .share({
            // title: heading,
            text: link,
            // url: shareUrl,
          })
          .then(() => {
            // console.log("Shared successfully.")
          })
          .catch(() => {
            // console.error("Error sharing:", error)
          });

        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(link).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      } else {
        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(link).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      }

      this.copiedDownloadLinkSnackbar = true;
    },

    catchUpReportingOrderProducts() {
      const d = new Date();
      d.setDate(d.getDate() - 1);   // yesterday
      d.setHours(0, 0, 0, 0);       // from its start...
      this.backfillReportingOrderProducts(d.toISOString()); // ...up to now
    },

        async backfillReportingOrderProducts(since = null) {
          this.backfillAnomalies = [];
      if (this.backfilling) return;
      this.backfilling = true;
      this.backfillError = null;
      this.backfillStats = {
        PAID: { orders: 0, skipped: 0, rows: 0, pages: 0 },
        PROCESSING: { orders: 0, skipped: 0, rows: 0, pages: 0 },
      };

      const API_NAME = "reportingorderproductsapi"; // <-- your REST API name for the function
      const PAGE_SIZE = 25; // raise (50–100) to finish faster, as long as each call stays < 29s

      try {
        for (const status of ["PAID", "PROCESSING"]) {
          let nextToken = null;
          do {
            const resp = await API.post(API_NAME, "/item/backfill", {
              body: { status, nextToken, pageSize: PAGE_SIZE, since },
            });

            if (resp.anomalyOrders && resp.anomalyOrders.length) {
              // cap so a pathological run can't balloon browser memory
              if (this.backfillAnomalies.length < 2000) {
                this.backfillAnomalies.push(...resp.anomalyOrders);
              }
            }

            const s = this.backfillStats[status];
            s.orders += resp.ordersWritten || 0;
            s.skipped += resp.ordersSkipped || 0;
            s.rows += resp.rowsCreated || 0;
            s.pages += 1;
            nextToken = resp.nextToken || null;
            await this.$nextTick(); // let the progress repaint between pages
          } while (nextToken);
        }
      } catch (e) {
        console.error("Backfill failed:", e);
        this.backfillError =
          e?.response?.data?.error || e.message || "Backfill failed";
      } finally {
        this.backfilling = false;
      }
    },

    getRecentMonths(count) {
      const months = [];
      let current = new Date();
      for (let i = 0; i < count; i++) {
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, "0");
        months.push(`${year}-${month}`);
        current.setMonth(current.getMonth() - 1);
      }
      console.log("getRecentMonths:", months);
      return months;
    },

    getMonthsInRange(startStr, endStr) {
      const months = [];
      const start = startStr ? new Date(startStr) : new Date("2000-01-01");
      const end = endStr ? new Date(endStr) : new Date();
      let current = new Date(start.getFullYear(), start.getMonth(), 1);
      const endMonthDate = new Date(end.getFullYear(), end.getMonth() + 1, 0);
      while (current <= endMonthDate) {
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, "0");
        months.push(`${year}-${month}`);
        current.setMonth(current.getMonth() + 1);
      }
      return months;
    },

    async loadOrders() {
      if (this.offline) return;

      const isTeacherView = this.isAmplifyDataStoreId(
        this.$route.params.teacherProfileId,
      );

      let fetchedItems = [];

      const startDate = new Date(this.filterStartDate).toISOString();

      const nextEndDay = new Date(this.filterEndDate);
      nextEndDay.setDate(nextEndDay.getDate() + 1);

      const endDate = nextEndDay.toISOString();

      console.log("Filtering orders with:", {
        filterStartDate: this.filterStartDate,
        filterEndDate: this.filterEndDate,
        filterStatuses: this.filterStatuses,
        startDate,
        endDate,
      });

      if (isTeacherView) {
        if (this.syncedProductOrders) return; // already fully loaded for teacher
        const teacherId = this.$route.params.teacherProfileId;
        try {
          const items = await this.fetchAllWithGSI(
            teacherProductsOrdersByTeacherprofileID,
            "teacherProductsOrdersByTeacherprofileID",
            {
              teacherprofileID: teacherId,
              filter: { orderStatus: { ne: "QUOTING" } },
            },
          );
          fetchedItems = items || [];
        } catch (e) {
          console.warn("Failed to load teacher orders", e);
        }
      } else {
        this.syncedProductOrders = false;

        // Admin view - dynamic loading based on filters
        const selectedStatuses =
          this.filterStatuses.length > 0 ? this.filterStatuses : null;

        const monthsInRange = this.getMonthsInRange(startDate, endDate);

        console.log("monthsInRange to fetch:", monthsInRange);

        // let items = await this.fetchAll(
        //   listTeacherProductsOrders,
        //   "listTeacherProductsOrders",
        //   { filter: { updatedAt: { beginsWith: "2026-02-03" } } },
        // );
        // fetchedItems = fetchedItems.concat(items || []);
        // console.log("fetchedItems:", fetchedItems);

        if (selectedStatuses) {
          // Query only selected statuses
          for (const status of selectedStatuses) {
            // for (const month of updatedMonths) {
            try {
              const items = await this.fetchAllWithGSI(
                teacherProductsOrdersByOrderStatus,
                "teacherProductsOrdersByOrderStatus",
                {
                  orderStatus: status,
                  updatedAt: {
                    between: [startDate, endDate],
                  },
                },
              );
              fetchedItems = fetchedItems.concat(items || []);
            } catch (e) {
              console.warn("Error fetching orders by status:", e);
            }
          }
        } else {
          // No status filter
          // UpdatedAtMonth - always all statuses
          for (const month of monthsInRange) {
            try {
              const items = await this.fetchAllWithGSI(
                teacherProductsOrdersByUpdatedAtMonth,
                "teacherProductsOrdersByUpdatedAtMonth",
                {
                  updatedAtMonth: month,
                  updatedAt: {
                    between: [startDate, endDate],
                  },
                  filter: { orderStatus: { ne: "QUOTING" } },
                },
              );
              fetchedItems = fetchedItems.concat(items || []);
            } catch (e) {
              console.warn("Error fetching orders by updatedAtMonth:", e);
            }
          }
        }

        // Deduplicate
        const seen = new Set();
        fetchedItems = fetchedItems.filter((item) => {
          if (!item?.id || seen.has(item.id)) return false;
          seen.add(item.id);
          return true;
        });
      }

      // Add only new items to the master list
      const currentIds = new Set(
        this.syncedProductOrderModels.map((o) => o.id),
      );
      const newItems = fetchedItems.filter((item) => !currentIds.has(item.id));

      if (newItems.length > 0 || this.syncedProductOrderModels.length === 0) {
        const combined = [...this.syncedProductOrderModels, ...newItems];
        this.handleProductOrdersUpdate(combined);
      }
    },

    async fetchAllWithGSI(query, queryName, variables = {}) {
      try {
        let items = [];
        let nextToken = null;

        do {
          const response = await API.graphql({
            query: query,
            variables: {
              ...variables,
              filter: {
                ...variables.filter,
                _deleted: { ne: true },
              },
              nextToken,
              limit: 4000,
            },
            authMode: this.authMode,
          });

          if (!response || !response.data) break;
          const page = response.data[queryName];
          const newItems = page?.items?.filter(Boolean) || [];
          items = items.concat(newItems);
          nextToken = page?.nextToken;
        } while (nextToken);

        items = this.parseGraphqlResult(items);

        // console.log(`Fetched ${items.length}: ${items} from ${queryName}`);

        return items;
      } catch (error) {
        console.error(`Error fetching items from ${queryName}:`, error);
        return [];
      }
    },

    async fetchAll(query, queryName, variables = {}) {
      try {
        let items = [];
        let nextToken = null;
        do {
          const res = await API.graphql({
            query,
            variables: {
              ...variables,
              filter: {
                ...variables.filter,
                _deleted: { ne: true },
              },
              nextToken,
              limit: 4000,
            },
            authMode: this.authMode,
          }).catch((error) => {
            console.error(`Error executing GraphQL query ${queryName}:`, error);
            return error || null;
          });

          // console.log(`result from ${queryName}:`, res);
          if (!res || !res.data) break;

          const page = res.data[queryName];
          const newItems = page?.items?.filter(Boolean) || [];

          items = items.concat(newItems);
          nextToken = res.data[queryName].nextToken;
        } while (nextToken);

        items = this.parseGraphqlResult(items);

        // console.log(`Fetched ${items.length} items from ${queryName}`);

        return items;
      } catch (error) {
        console.error(`Error fetching items from ${queryName}:`, error);
        return [];
      }
    },

    // getRecentMonths(howMany = 8) {
    //   const months = [];
    //   const now = new Date();
    //   for (let i = 0; i < howMany; i++) {
    //     const d = new Date(now.getFullYear(), now.getMonth() + 1 - i, 1);
    //     months.push(d.toISOString().slice(0, 7)); // "2026-01"
    //   }
    //   // console.log("Recent months:", months);
    //   return months; // newest → oldest
    // },

    async updateAllOrderUpdatedStatuses() {
      try {
        // Make a shallow copy to avoid mutating the original array during processing
        const ordersToUpdate = [...this.syncedProductOrderModels];

        const CONCURRENCY_LIMIT = 100; // Adjust based on testing (100–200 is usually safe for AppSync + browser)
        const failedOrders = []; // Track failures for potential retry

        // Simple concurrency limiter using chunked Promise.all
        const processBatch = async (batch) => {
          return Promise.allSettled(
            batch.map(async (order) => {
              try {
                console.log("order to update:", order);
                const newUpdatedAt =
                  order.orderDateTime > ""
                    ? order.orderDateTime
                    : order.createdAt;
                console.log("newUpdatedAt:", newUpdatedAt);
                console.log(
                  'order.orderDateTime > "":',
                  order.orderDateTime > "",
                );

                if (newUpdatedAt === order.updatedAt) {
                  return { success: true, orderId: order.id };
                }

                const input = {
                  id: order.id,
                  _version: order._version,
                  updatedAtMonth: newUpdatedAt.slice(0, 7),
                  // createdAtMonth: order.createdAt.slice(0, 7),
                  updatedAt: newUpdatedAt,
                };

                // Use graphqlOperation if you imported the mutation, otherwise keep your current style
                const response = await API.graphql(
                  // graphqlOperation(updateTeacherProductsOrder, { input })
                  // or your existing syntax:
                  {
                    query: updateTeacherProductsOrder,
                    variables: { input },
                    authMode: this.authMode,
                  },
                );

                // FIX: The mutation almost certainly returns updateTeacherProductsOrder, not getTeacherProductsOrder
                const latestOrder = response.data?.updateTeacherProductsOrder;

                if (!latestOrder) {
                  throw new Error("No updated order returned");
                }

                // Sync any server-side changes (e.g. orderStatus) into your local model
                if (latestOrder.orderStatus !== order.orderStatus) {
                  Object.assign(order, latestOrder);
                }

                // Optionally update _version explicitly if you don't assign the whole object
                // order._version = latestOrder._version;

                return { success: true, orderId: order.id };
              } catch (error) {
                // Handle optimistic concurrency conflict gracefully
                if (
                  error.errors?.some(
                    (e) => e.errorType === "ConditionalCheckFailedException",
                  )
                ) {
                  console.warn(
                    `Version conflict for order ${order.id} – someone else updated it. Consider refetching.`,
                  );
                } else {
                  console.error(`Error updating order ${order.id}:`, error);
                }
                return { success: false, orderId: order.id, error };
              }
            }),
          );
        };

        // Process in chunks to respect concurrency limit
        for (let i = 0; i < ordersToUpdate.length; i += CONCURRENCY_LIMIT) {
          const batch = ordersToUpdate.slice(i, i + CONCURRENCY_LIMIT);
          console.log(
            `Processing batch ${
              Math.floor(i / CONCURRENCY_LIMIT) + 1
            } of ${Math.ceil(ordersToUpdate.length / CONCURRENCY_LIMIT)} (${
              batch.length
            } orders)`,
          );

          const results = await processBatch(batch);

          // Collect failures for logging/retry
          results.forEach((result) => {
            if (result.status === "rejected" || !result.value.success) {
              failedOrders.push(result.value?.orderId || "unknown");
            }
          });

          // Optional: small delay between batches to be gentle on AppSync throttling
          // await new Promise(resolve => setTimeout(resolve, 100));
        }

        console.log(
          `Update complete. Success: ${
            ordersToUpdate.length - failedOrders.length
          }, Failed: ${failedOrders.length}`,
        );
        if (failedOrders.length > 0) {
          console.warn("Failed order IDs:", failedOrders);
          // You could add a retry button that re-runs only the failed ones
        }
      } catch (error) {
        console.error("Fatal error in updateAllOrderUpdatedStatuses:", error);
      }
    },

    parseGraphqlResult(data) {
      if (data === null || data === undefined) return data;

      // If it's an array, map over it recursively
      if (Array.isArray(data)) {
        return data.map(this.parseGraphqlResult);
      }

      // If it's an object, iterate keys
      if (typeof data === "object") {
        const parsedObject = {};
        for (const [key, value] of Object.entries(data)) {
          parsedObject[key] = this.parseGraphqlResult(value);
        }
        return parsedObject;
      }

      // If it's a string, try to parse it
      if (typeof data === "string") {
        try {
          // Basic check to avoid parsing simple strings like "Hello"
          // Only parse if it starts with { or [
          const trimmed = data.trim();
          if (
            (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
            (trimmed.startsWith("[") && trimmed.endsWith("]"))
          ) {
            return JSON.parse(data);
          }
        } catch (e) {
          // If parsing fails, just return the original string
          return data;
        }
      }

      return data;
    },

    async handleProductOrdersUpdate(items, isSynced = true) {
      if (items) {
        this.syncedProductOrderModels = items;

        // console.log("handleProductOrdersUpdate - items:", items);

        // productOrder ids that contain product with questions
        this.syncedPOIDsWithQuestions = items
          .filter((item) =>
            item.orderProducts?.some(
              (product) =>
                Array.isArray(product.questions) &&
                product.questions.length > 0,
            ),
          )
          .map((item) => item.id);

        // productOrder ids that contain product that's physical
        this.syncedPOIDsWithPhysical = items
          .filter((item) =>
            item.orderProducts?.some((product) => product.physical === true),
          )
          .map((item) => item.id);

        const isValidTeacherProfileId = this.isAmplifyDataStoreId(
          this.$route.params.teacherProfileId,
        );

        if (isValidTeacherProfileId) {
          this.productOrderModels = _.filter(
            items,
            (item) =>
              item.teacherprofileID === this.$route.params.teacherProfileId,
          );
        } else {
          this.productOrderModels = _.cloneDeep(items);
        }

        // Handle route params logic
        if (typeof this.$route.params === "object") {
          if (typeof this.$route.params.orderId === "string") {
            const order = _.find(items, {
              orderID: this.$route.params.orderId,
            });
            if (order) {
              this.viewItem(order);
            }
          } else if (
            this.isValidOwnerField(this.decodedRouteParamOwner) &&
            isValidTeacherProfileId &&
            typeof this.$route.params.action === "string" &&
            this.$route.params.action === "new"
          ) {
            this.createItem();
          }
        }
      }

      if (isSynced) {
        this.syncedProductOrders = true;
      } else {
        this.syncedProductOrders = false;
      }
    },

    async handleProductsUpdate(items, isSynced = true) {
      if (items) {
        this.syncedProductModels = items;
        this.productModels = _.cloneDeep(items);
      }

      if (isSynced) {
        this.syncedProducts = true;
      } else {
        this.syncedProducts = false;
      }
    },

    async handleProductBundlesUpdate(items, isSynced = true) {
      if (items) {
        this.syncedProductBundleModels = items;
        this.productBundleModels = _.cloneDeep(items);
      }

      if (isSynced) {
        this.syncedProductBundles = true;
      } else {
        this.syncedProductBundles = false;
      }
    },

    async handleSecretsUpdate(items, isSynced = true) {
      if (
        items &&
        JSON.stringify(this.syncedSecretArray) !== JSON.stringify(items)
      ) {
        this.syncedSecretArray = items;
      }

      if (isSynced) {
        this.secretSubscriptionSynced = true;
      }
    },

    orderToCoupon(orderTimestamp) {
      const secretSalt = this.syncedSecretArray.find(
        (obj) => obj.type === "SecureCouponSystemSalt",
      )?.value?.secretSalt;
      const SALT = secretSalt; // ← never change this value after deployment

      // console.log("SALT", SALT);

      const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
      const MIN_LENGTH = 6;

      const num = Number(orderTimestamp);

      if (isNaN(num) || num < 0) return "ERROR";

      let str = num.toString(36) + SALT;
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
      }

      let result = "";
      hash = Math.abs(hash);

      while (hash > 0 || result.length < MIN_LENGTH) {
        result = ALPHABET[hash % ALPHABET.length] + result;
        hash = Math.floor(hash / ALPHABET.length);
      }

      return result.slice(0, 12); // reasonable max length
    },
    removeAddonFromProduct(product, addon) {
      const productIndex = this.editedItem.orderProducts.findIndex(
        (p) => p.id === product.id,
      );
      // console.log("productIndex", productIndex);
      if (productIndex !== -1) {
        const addonIndex = this.editedItem.orderProducts[productIndex].addons
          ? this.editedItem.orderProducts[productIndex].addons.findIndex(
              (a) => a.title === addon.title && a.type === addon.type,
            )
          : -1;
        // console.log("addonIndex", addonIndex);
        if (addonIndex !== -1) {
          this.editedItem.orderProducts[productIndex].addons.splice(
            addonIndex,
            1,
          );
        }
      }
    },
    getAvailableAddons(productId) {
      const originalProduct = [
        ...this.syncedProductModels,
        ...this.syncedProductBundleModels,
      ].find((p) => p.id === productId);
      return originalProduct?.addons || [];
    },

    openNotesDialog(item) {
      this.editedItem = _.cloneDeep(item);
      this.newNote = "";
      this.notesDialog = true;
    },

    async saveNote() {
      if (!this.newNote) return;

      const user = await Auth.currentAuthenticatedUser().catch(() => {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      });

      if (user) {
        const userName = user.username;

        const newNoteObj = {
          note: this.newNote,
          timestamp: new Date().toISOString(),
          username: userName,
        };
        const updatedNotes = [...(this.editedItem.notes || []), newNoteObj];

        // await DataStore.save(
        //   TeacherProductsOrder.copyOf(
        //     _.find(this.syncedProductOrderModels, { id: this.editedItem.id }),
        //     (updated) => {
        //       updated.notes = updatedNotes;
        //     }
        //   )
        // );

        // save notes via appsync

        await API.graphql({
          query: updateTeacherProductsOrder,
          variables: {
            input: {
              id: this.editedItem.id,
              _version: this.editedItem._version,
              notes: JSON.stringify(updatedNotes),
            },
          },
          authMode: this.authMode,
        });

        this.notesDialog = false;
        this.resetForm();
      }
    },

    canSendOrderEmail(order) {
      const emailType = this.orderEmailType;

      if (
        order.orderStatus === "PAID" &&
        (emailType === "PAID" || emailType === "INVOICE")
      ) {
        return true;
      } else if (
        (order.orderPaymentMethod === "EFT" ||
          order.orderPaymentMethod === "Free") &&
        order.orderStatus === "PROCESSING" &&
        emailType === "PROCESSING"
      ) {
        return true;
      } else if (
        //orders that have been pending for more than 1 days without a coupon or discounted products
        emailType === "ABANDONED CART 10% DISCOUNT OFFER" &&
        order.orderStatus === "PENDING" &&
        new Date(order.createdAt) <=
          new Date(Date.now() - 1 * 24 * 60 * 60 * 1000) &&
        (!order.coupon || order.coupon === "") &&
        !order.orderProducts?.some(
          (product) =>
            product.discountPercentage && product.discountPercentage > 0,
        ) &&
        // calculate total price to ensure it's greater than 0
        order.orderProducts?.reduce((total, product) => {
          return total + product.price;
        }, 0) >= 30
      ) {
        return true;
      } else if (
        //PAID orders that have a specific productID in their orderProducts
        (emailType === "PRODUCT OUTDATED") & (order.orderStatus === "PAID") &&
        order.orderProducts?.some((product) => this.search === product.id)
      ) {
        return true;
      } else return false;
    },

    async sendProductOrderEmail(order) {
      try {
        this.$set(this.sendingEmails, order.id, true);

        const user = await Auth.currentAuthenticatedUser().catch(() => {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        });

        if (!user) return;

        if (this.orderEmailType === "ABANDONED CART 10% DISCOUNT OFFER") {
          //generate a coupon code for 10% discount

          // const newCoupon = await DataStore.save(
          //   new Coupon({
          //     couponCode: this.orderToCoupon(
          //       new Date(order.createdAt).getTime()
          //     ),
          //     enabled: true,
          //     startDate: new Date().toISOString().split("T")[0],
          //     endDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000)
          //       .toISOString()
          //       .split("T")[0], //valid for 2 days,
          //     discount: {
          //       type: "PERCENTAGE",
          //       value: 10,
          //     },
          //     restrictTo: {
          //       type: "Teachers",
          //       value: [order.teacherprofileID],
          //     },
          //   })
          // );

          const newCoupon = {
            couponCode: this.orderToCoupon(new Date(order.createdAt).getTime()),
            enabled: true,
            startDate: new Date().toISOString().split("T")[0],
            endDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000)
              .toISOString()
              .split("T")[0], //valid for 2 days,
            discount: {
              type: "PERCENTAGE",
              value: 10,
            },
            restrictTo: {
              type: "Teachers",
              value: [order.teacherprofileID],
            },
          };

          await API.graphql({
            query: createCoupon,
            variables: {
              input: {
                couponCode: newCoupon.couponCode,
                enabled: newCoupon.enabled,
                startDate: newCoupon.startDate,
                endDate: newCoupon.endDate,
                discount: JSON.stringify(newCoupon.discount),
                restrictTo: JSON.stringify(newCoupon.restrictTo),
              },
            },
            authMode: this.authMode,
          });

          // console.log("Generated coupon for abandoned cart:", newCoupon);

          //attach the coupon code to the order object for email sending
          order.coupon = newCoupon;

          //save the order with the new coupon code
          // await DataStore.save(
          //   TeacherProductsOrder.copyOf(
          //     _.find(this.syncedProductOrderModels, { id: order.id }),
          //     (updated) => {
          //       updated.coupon = newCoupon;
          //     }
          //   )
          // );

          // save the order with the new coupon code - appsync
          await API.graphql({
            query: updateTeacherProductsOrder,
            variables: {
              input: {
                id: order.id,
                _version: order._version,
                coupon: JSON.stringify(newCoupon),
              },
            },
            authMode: this.authMode,
          });

          // await DataStore.save(
          //   new Announcement({
          //     title: `10% Discount Coupon for Your Incomplete Order`,
          //     sendTo: [order.teacherprofileID],
          //     message: `We noticed that you left some items in your cart. To help you complete your purchase, we've created a special 10% discount coupon just for you! Use the code ${newCoupon.couponCode} at checkout. Hurry, this offer is valid until ${newCoupon.endDate}.`,
          //   })
          // );

          // announcement via appsync

          await API.graphql({
            query: createAnnouncement,
            variables: {
              input: {
                title: `10% Discount Coupon for Your Incomplete Order`,
                sendTo: JSON.stringify([order.teacherprofileID]),
                message: `We noticed that you left some items in your cart. To help you complete your purchase, we've created a special 10% discount coupon just for you! Use the code ${newCoupon.couponCode} at checkout. Hurry, this offer is valid until ${newCoupon.endDate}.`,
              },
            },
            authMode: this.authMode,
          });
        }

        const response = await API.post(
          "adminlambdaapi",
          "/item/sendProductOrderEmail",
          {
            body: {
              emailType: this.orderEmailType,
              order,
              productID:
                this.orderEmailType === "PRODUCT OUTDATED" ? this.search : null,
            },
          },
        );

        if (response.success) {
          console.log(`Sent order email successfully, response: ${response}`);
          this.snackbarText = `Email sent successfully for order ${order.orderID}`;
          this.snackbarColor = "success";
          this.snackbar = true;
        }
      } catch (error) {
        console.error(`Error sending order email, error:`, error);
        this.snackbarText = `Error sending email for order ${order.orderID}: ${
          error.message || "Unknown error"
        }`;
        this.snackbarColor = "error";
        this.snackbar = true;
      } finally {
        this.$set(this.sendingEmails, order.id, false);
      }
    },

    customSort(items, sortBy, sortDesc) {
      return items.slice().sort((a, b) => {
        for (let i = 0; i < sortBy.length; i++) {
          const key = sortBy[i];
          const isDescending = sortDesc[i] ? -1 : 1;

          // ✅ Custom sorting logic for specific columns
          if (key === "physical") {
            return (
              (this.syncedPOIDsWithPhysical.includes(b.id) -
                this.syncedPOIDsWithPhysical.includes(a.id)) *
              isDescending
            );
          }

          if (key === "questions") {
            return (
              (this.syncedPOIDsWithQuestions.includes(b.id) -
                this.syncedPOIDsWithQuestions.includes(a.id)) *
              isDescending
            );
          }

          // Default sorting logic
          let aValue = a[key];
          let bValue = b[key];

          // Convert AWS date-time strings to Date objects for proper sorting
          if (key === "orderDateTime") {
            aValue = new Date(aValue);
            bValue = new Date(bValue);
          }

          if (aValue < bValue) return -1 * isDescending;
          if (aValue > bValue) return 1 * isDescending;
        }
        return 0;
      });
    },

    async archiveProductOrders() {
      const user = await Auth.currentAuthenticatedUser().catch(() => {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      });
      const orders = this.syncedProductOrderModels;
      let owners = [];
      let startFromOrderID = false;
      let count = 0;

      for (let i = 0; i < orders.length; i++) {
        if (!startFromOrderID) {
          //MAPI7 1st loop restart point
          //RMKOA 2nd loop restart point
          //RC0V5 3rd loop restart point
          //LLHSV 4th loop restart point
          //LGOXB 5th loop restart point
          //VSI3O 6th loop restart point
          //BSRY4 7th loop restart point
          //VIU8V 8th loop restart point
          //I0LLF 9th loop restart point
          //GDRGX 10th loop restart point
          //OE2J4 11th loop restart point
          //57H9S 12th loop restart point
          //RKCKC end loop point
          if (orders[i].orderID === "57H9S") {
            console.log("Found starting order", orders[i].orderID, i);
            startFromOrderID = true; // Set to true when "MAPI7" is encountered
          } else {
            console.log("Skipping order", orders[i].orderID, i);
          }
          continue; // Skip the rest of the logic for this iteration
        }

        // Delete order only if orderID startsWith 202
        if (
          (orders[i].orderStatus && orders[i].orderStatus === "PENDING") ||
          !orders[i].orderID ||
          orders[i].orderID.startsWith("202")
        ) {
          console.log(
            "Skipping order",
            orders[i].orderID,
            orders[i].orderStatus,
            i,
          );
          continue;
        }

        if (count === 1000) {
          //stop loop
          break;
        }

        let currentOwner = "";

        if (!owners.includes(orders[i].owner)) {
          const cognitoSub = await this.getUserOwner(
            user.pool.userPoolId,
            orders[i].owner,
          );

          if (!cognitoSub || cognitoSub === "") {
            console.log("Owner not found", orders[i].orderID, i);
            continue;
          }
          const owner = `${cognitoSub}::${orders[i].owner}`;

          owners.push(owner);
          currentOwner = owner;
        } else {
          currentOwner = owners.find(orders[i].owner);
        }

        // console.log("currentOwner", currentOwner);
        count++;

        // await API.graphql({
        //   query: updateTeacherProductsOrder,
        //   variables: {
        //     input: { id: orders[i].id, archived: true, _version: orders[i]._version },
        //   },
        //   authMode: this.authMode,
        // });

        const uniqueProducts = _.uniqBy(orders[i].orderProducts, "id");

        let objToSave = {
          teacherprofileID: orders[i].teacherprofileID,
          orderDateTime: orders[i].orderDateTime,
          orderStatus: orders[i].orderStatus,
          orderProducts: JSON.stringify(uniqueProducts),
          orderTotal: orders[i].orderTotal,
          orderVAT: orders[i].orderVAT,
          orderID: orders[i].orderID,
          orderPaymentMethod: orders[i].orderPaymentMethod,
          owner: currentOwner,
        };

        if (orders[i].orderShippingDetails) {
          objToSave.orderShippingDetails = JSON.stringify(
            orders[i].orderShippingDetails,
          );
        }
        if (orders[i].orderPayment) {
          objToSave.orderPayment = JSON.stringify(orders[i].orderPayment);
        }
        if (orders[i].coupon) {
          objToSave.coupon = JSON.stringify(orders[i].coupon);
        }

        await API.graphql({
          query: createArchivedTeacherProductsOrder,
          variables: { input: objToSave },
          authMode: this.authMode,
        });
        console.log("Archived order", orders[i].orderID, i);
      }

      console.log("DONE - Archived orders");
    },

    async getUserOwner(userPoolId, username) {
      AWS.config.update({
        region: "eu-west-2",
        accessKeyId: "",
        secretAccessKey: "",
      });

      // Create an instance of the CognitoIdentityServiceProvider
      const CognitoIdentityServiceProvider =
        new AWS.CognitoIdentityServiceProvider();

      const getUserParams = {
        UserPoolId: userPoolId /* required */,
        Username: username /* required */,
      };

      const userData = await CognitoIdentityServiceProvider.adminGetUser(
        getUserParams,
      ).promise();

      let cognitoSub = this.getCognitoAttributeValue(
        userData.UserAttributes,
        "sub",
      );

      return cognitoSub;
    },

    async deleteProductOrders() {
      const orders = this.syncedProductOrderModels;
      // let count = 0;

      for (let i = 0; i < orders.length; i++) {
        // Delete order only if orderID startsWith 202
        if (
          (orders[i].orderStatus && orders[i].orderStatus === "PENDING") ||
          !orders[i].orderID ||
          orders[i].orderID.startsWith("202")
        ) {
          console.log(
            "Skipping order",
            orders[i].orderID,
            orders[i].orderStatus,
            i,
          );
          continue;
        }

        // if (count === 10000) {
        //   //stop loop
        //   break;
        // }

        // count++;
        await API.graphql({
          query: deleteTeacherProductsOrder,
          variables: { input: { id: orders[i].id } },
          authMode: this.authMode,
        });
        console.log("Deleted order", orders[i].orderID, i);
      }
      console.log("DONE - Deleted orders");
    },

    getCognitoAttributeValue(attributesArray, attrName) {
      if (typeof attributesArray !== "object") return "";
      for (const attribute of attributesArray) {
        if (attribute.Name === attrName) {
          return attribute.Value;
        }
      }
      return "";
    },

    onCouponCodeInput(value) {
      // Convert to uppercase and remove non-alphanumeric characters
      this.couponCode = value
        ? value
            .trim()
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
        : "";
    },

    // couponText(coupon) {
    //   if (coupon) {
    //     return coupon.discount.type === "PERCENTAGE"
    //       ? `- ${coupon.discount.value}%`
    //       : `- R${coupon.discount.value.toFixed(2)}`;
    //   } else {
    //     return "";
    //   }
    // },

    async verifyCoupon() {
      if (this.couponCode === "") {
        this.couponVerifyErrors = ["Coupon code is required"];
        return;
      }

      this.verifyingCoupon = true;
      try {
        await API.get("couponapi", "/item/verifyCoupon", {
          queryStringParameters: {
            teacherProfileID:
              this.$route.params?.teacherProfileId ||
              this.editedItem.teacherprofileID,
            couponCode: this.couponCode,
          },
        })
          .then(async (response) => {
            if (response?.validCoupon) {
              this.couponVerifyErrors = [];
              // this.validCoupon = response.validCoupon;
              this.editedItem.coupon = response.validCoupon;
              console.log(this.validCoupon);
            } else {
              this.couponVerifyErrors = [response.error];
              // this.validCoupon = null;
              this.editedItem.coupon = null;
            }

            this.verifyingCoupon = false;
          })
          .catch((error) => {
            console.log(error);
            this.couponVerifyErrors = [
              "An error occurred while verifying the coupon, please check your internet connection or try again later.",
            ];
            // this.validCoupon = null;
            this.editedItem.coupon = null;

            this.verifyingCoupon = false;
          });
      } catch (error) {
        console.log(error);
      }
    },

    updateOrderProducts() {
      // console.log("updateOrderProducts");
      this.editedItem.orderProducts = this.editedItem.orderProducts.map(
        (product) => _.cloneDeep(product),
      );

      if (
        this.editedItem.orderProducts?.length === 0 ||
        this.editedItemSubTotal > 0
      ) {
        this.editedItem.orderPaymentMethod = "EFT";
      } else if (this.editedItemSubTotal === 0) {
        this.editedItem.orderPaymentMethod = "Free";
      }
    },

    async saveTeacherShippingDetails() {
      try {
        this.savingTeacherShippingDetails = true;
        await API.put("shippingapi", "/item/saveTeacherShippingDetails", {
          body: {
            teacherProfileID: this.$route.params.teacherProfileId,
            shippingDetails: this.shippingDetails,
          },
          // headers: {} // OPTIONAL
        })
          .then(async (response) => {
            if (response.error) {
              console.log(response.error);
            } else if (typeof response.success === "string") {
              // console.log("Shipping details saved successfully");
              this.syncedShippingDetails = _.cloneDeep(this.shippingDetails);
            }
            this.savingTeacherShippingDetails = false;
            this.savedShippingDetails = true;
            setTimeout(() => {
              this.savedShippingDetails = false;
            }, 5000);
          })
          .catch((error) => {
            console.log(error);
            this.savingTeacherShippingDetails = false;
          });
      } catch (error) {
        console.log(error);
        this.savingTeacherShippingDetails = false;
      }
    },

    async fetchTeacherShippingDetails() {
      try {
        this.gettingTeacherShippingDetails = true;
        await API.get("shippingapi", "/item/getTeacherShippingDetails", {
          queryStringParameters: {
            teacherProfileID: this.$route.params.teacherProfileId,
          },
        })
          .then(async (response) => {
            if (response.error) {
              console.log(response.error);
            } else if (typeof response.shippingDetails === "string") {
              this.noShippingDetailsFound = false;
              const responseShippingDetails = JSON.parse(
                response.shippingDetails,
              );
              // this.editedItem.orderShippingDetails = responseShippingDetails;
              this.shippingDetails = _.cloneDeep(responseShippingDetails);
              this.syncedShippingDetails = _.cloneDeep(responseShippingDetails);
            } else {
              // console.log("No shipping details found");
              this.noShippingDetailsFound = true;
              setTimeout(() => {
                this.noShippingDetailsFound = false;
              }, 5000);
            }

            this.gettingTeacherShippingDetails = false;
          })
          .catch((error) => {
            console.log(error);
            this.gettingTeacherShippingDetails = false;

            this.noShippingDetailsFound = true;
            setTimeout(() => {
              this.noShippingDetailsFound = false;
            }, 5000);
          });
      } catch (error) {
        console.log(error);
        this.gettingTeacherShippingDetails = false;

        this.noShippingDetailsFound = true;
        setTimeout(() => {
          this.noShippingDetailsFound = false;
        }, 5000);
      }
    },

    copyPlaceholderToValue(question) {
      if (!question.value && question.placeholder) {
        question.value = question.placeholder;
      }
    },

    async save() {
      this.savingProductOrder = true;
      if (this.editedIndex > -1) {
        // Update Product Order
        await this.updateProductOrder();
      } else {
        // Create new Product Order
        await this.createProductOrder();
      }
      this.close();
      this.savingProductOrder = false;
    },

    async sendPurchaseEvent(obj) {
      // const payload = {
      //   user_id: obj.teacherprofileID, // Use teacherprofileID as user_id
      //   events: [
      //     {
      //       name: "purchase",
      //       params: {
      //         transaction_id: obj.orderID,
      //         value: obj.orderTotal,
      //         currency: "ZAR",
      //         tax: obj.orderVAT,
      //         items: obj.orderProducts.map((product) => ({
      //           item_id: product.id,
      //           item_name: product.title,
      //           price: product.price,
      //           quantity: 1,
      //           item_category: product.categoryId,
      //         })),
      //       },
      //     },
      //   ],
      // };

      // const apiSecret = this.syncedSecretArray.find(
      //   (obj) => obj.type === "GAnalytics_JuffrouAnriAdminKey",
      // )?.value?.secretKey;

      // try {
      //   const response = await fetch(
      //     `https://www.google-analytics.com/mp/collect?measurement_id=G-4JPZRSY7H4&api_secret=${apiSecret}`,
      //     {
      //       method: "POST",
      //       body: JSON.stringify(payload),
      //     },
      //   );
      //   if (!response.ok) {
      //     console.error("Failed to send purchase event:", response.statusText);
      //   }
      // } catch (error) {
      //   console.error("Error sending purchase event:", error);
      // }

      window.dataLayer = window.dataLayer || [];

      const dataLayerObj = {
        event: "purchase",
        transaction_id: obj.orderID, // GA4 prefers 'transaction_id'
        value: obj.orderTotal, // GA4 prefers 'value' for total revenue
        currency: "ZAR",
        tax: obj.orderVAT, // Optional: include VAT if desired
        ...buildTrackingDataLayerFields(obj.meta),
        items: obj.orderProducts.map((product) => {
          let price =
            product.price && product.discountPercentage
              ? product.price -
                product.price * (product.discountPercentage / 100)
              : product.price;

          if (!product.physical && obj.coupon) {
            const parsedCoupon =
              typeof obj.coupon === "string"
                ? JSON.parse(obj.coupon)
                : obj.coupon;

            if (parsedCoupon) {
              const percentageType =
                parsedCoupon.discount.type === "PERCENTAGE";

              price = percentageType
                ? price - price * (parsedCoupon.discount.value / 100)
                : price - parsedCoupon.discount.value;
            }
          }

          return {
            item_id: product.id, // Use 'sku' as a unique identifier
            item_name: product.title, // Product name
            price: price, // Unit price of the item
            quantity: 1, // Assume 1 unless quantity exists
            item_category: product.categoryId, // Category identifier
          };
        }),
      };

      console.log("Pushing to dataLayer:", dataLayerObj);

      window.dataLayer.push(dataLayerObj);
    },

    async createProductOrder() {
      try {
        const newOrderID = this.generateOrderID();

        const uniqueProducts = _.uniqBy(this.editedItem.orderProducts, "id");
        const newProducts = uniqueProducts.map((obj) => {
          const newObj = { ...obj };

          if (newObj.thumbnailImages) delete newObj.thumbnailImages;
          if (newObj.searchField) delete newObj.searchField;
          if (newObj.description) delete newObj.description;
          if (newObj.displayItems) delete newObj.displayItems;
          if (newObj.createdAt) delete newObj.createdAt;
          if (newObj.updatedAt) delete newObj.updatedAt;
          if (newObj.featured) delete newObj.featured;
          if (newObj.thumbnails) delete newObj.thumbnails;
          if (newObj.type) delete newObj.type;
          if (newObj.videoPreview) delete newObj.videoPreview;
          if (newObj._lastChangedAt) delete newObj._lastChangedAt;
          if (newObj.__typename) delete newObj.__typename;

          return newObj;
        });

        const orderStatus =
          this.editedItem.orderPaymentMethod === "EFT" ? "PROCESSING" : "PAID";

        const orderTotal = parseFloat(this.editedItemSubTotal.toFixed(2));
        const orderVAT = parseFloat(this.editedItemTotalVat.toFixed(2));

        const newOrderMonth = new Date().toISOString().slice(0, 7);

        const input = {
          orderDateTime: new Date().toISOString(),
          orderID: newOrderID,
          orderPaymentMethod: this.editedItem.orderPaymentMethod,
          orderProducts: JSON.stringify(newProducts),
          orderTotal: orderTotal,
          orderVAT: orderVAT,
          coupon: this.editedItem.coupon
            ? JSON.stringify(this.editedItem.coupon)
            : null,
          orderShippingDetails:
            this.editedItemPhysicalProducts?.length > 0
              ? JSON.stringify(this.shippingDetails)
              : null,
          orderStatus: orderStatus,
          createdAtMonth: newOrderMonth,
          updatedAtMonth: newOrderMonth,
          owner: this.decodedRouteParamOwner,
          teacherprofileID: this.$route.params.teacherProfileId,
        };

        const newProductOrder = await API.graphql({
          query: createTeacherProductsOrder,
          variables: { input },
          authMode: this.authMode,
        }).then((res) => res.data.createTeacherProductsOrder);

        if (orderStatus === "PAID") {
          const purchaseEventObj = {
            teacherprofileID: this.$route.params.teacherProfileId,
            orderID: newOrderID,
            orderTotal,
            orderVAT,
            orderProducts: newProducts,
            coupon: this.editedItem.coupon,
            meta: this.editedItem.meta, // string or object – helper handles both
          };

          await this.sendPurchaseEvent(purchaseEventObj);
        }
      } catch (error) {
        console.log("Error creating product order:", error);
      }
    },

    async updateProductOrder() {
      try {
        const prevOrder = this.syncedProductOrderModels.find(
          (order) => order.id === this.editedItem.id,
        );

        console.log("this.editedItem.orderID", this.editedItem.orderID);

        const existingOrderID = this.editedItem.orderID;

        const newOrderID = existingOrderID && existingOrderID > ''
          ? existingOrderID
          : this.generateOrderID();

        const uniqueProducts = _.uniqBy(this.editedItem.orderProducts, "id");

        const newProducts = uniqueProducts.map((obj) => {
          const newObj = { ...obj };

          if (newObj.thumbnailImages) delete newObj.thumbnailImages;
          if (newObj.searchField) delete newObj.searchField;
          if (newObj.description) delete newObj.description;
          if (newObj.displayItems) delete newObj.displayItems;
          if (newObj.createdAt) delete newObj.createdAt;
          if (newObj.updatedAt) delete newObj.updatedAt;
          if (newObj.featured) delete newObj.featured;
          if (newObj.thumbnails) delete newObj.thumbnails;
          if (newObj.type) delete newObj.type;
          if (newObj.videoPreview) delete newObj.videoPreview;
          if (newObj._lastChangedAt) delete newObj._lastChangedAt;
          if (newObj.__typename) delete newObj.__typename;

          return newObj;
        });

        const orderTotal = parseFloat(this.editedItemSubTotal.toFixed(2));
        const orderVAT = parseFloat(this.editedItemTotalVat.toFixed(2));

        // Fetch current for _version
        const current = await API.graphql({
          query: getTeacherProductsOrder,
          variables: {
            id: this.editedItem.id,
            filter: { _deleted: { ne: true } },
          },
          authMode: this.authMode,
        }).then((res) => res.data.getTeacherProductsOrder);

        console.log("current _version", current._version);
        console.log("this.editedItem _version", this.editedItem._version);

        await API.graphql({
          query: updateTeacherProductsOrder,
          variables: {
            input: {
              id: this.editedItem.id,
              orderStatus: this.editedItem.orderStatus,
              orderID: newOrderID,
              orderProducts: JSON.stringify(newProducts),
              orderTotal: orderTotal,
              orderVAT: orderVAT,
              coupon: this.editedItem.coupon
                ? JSON.stringify(this.editedItem.coupon)
                : null,
              orderShippingDetails:
                this.editedItemPhysicalProducts?.length > 0
                  ? JSON.stringify(this.shippingDetails)
                  : null,
              updatedAtMonth: new Date().toISOString().slice(0, 7),
              _version: this.editedItem._version,
            },
          },
          authMode: this.authMode,
        });

        if (
          ((prevOrder && prevOrder.orderStatus !== "PAID") || !prevOrder) &&
          this.editedItem.orderStatus === "PAID"
        ) {
          const purchaseEventObj = {
            teacherprofileID: this.$route.params.teacherProfileId,
            orderID: this.editedItem.orderID,
            orderTotal,
            orderVAT,
            orderProducts: newProducts,
            coupon: this.editedItem.coupon,
            meta: this.editedItem.meta, // string or object – helper handles both
          };

          await this.sendPurchaseEvent(purchaseEventObj);
        }
      } catch (error) {
        console.log("Error updating product order:", error);
      }
    },

    generateOrderID() {
      const now = new Date();
      const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hour = now.getHours().toString().padStart(2, "0");
      const minute = now.getMinutes().toString().padStart(2, "0");
      const second = now.getSeconds().toString().padStart(2, "0");
      const millisecond = Math.floor(now.getMilliseconds() / 10)
        .toString()
        .padStart(2, "0");
      return `${year}${month}${day}-${hour}${minute}${second}${millisecond}`;
    },

    isValidOwnerField(owner) {
      // console.log("isValidOwnerField", owner);
      // Regular expression to validate the format cognitoSub::username
      const ownerRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}::[^ ]{1,}$/i;

      // console.log(ownerRegex.test(owner));
      return ownerRegex.test(owner);
    },

    isAmplifyDataStoreId(id) {
      // console.log("isAmplifyDataStoreId", id);
      // Regular expression to check UUID format
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

      // console.log(uuidRegex.test(id));
      return uuidRegex.test(id);
    },

    async syncProductOrders() {
      try {
        console.log("syncProductOrders");
        await this.loadOrders();

        const isValidTeacherProfileId = this.isAmplifyDataStoreId(
          this.$route.params.teacherProfileId,
        );

        this.productOrdersSubCreate = API.graphql({
          query: onCreateTeacherProductsOrder,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const created = this.parseGraphqlResult(
              value.data.onCreateTeacherProductsOrder,
            );
            if (created) {
              if (
                !isValidTeacherProfileId ||
                created.teacherprofileID === this.$route.params.teacherProfileId
              ) {
                const currentItems = this.syncedProductOrderModels || [];
                const newItems = [...currentItems, created];
                this.handleProductOrdersUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.productOrdersSubUpdate = API.graphql({
          query: onUpdateTeacherProductsOrder,
          variables: { filter: { _deleted: { ne: true } } },
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const updated = this.parseGraphqlResult(
              value.data.onUpdateTeacherProductsOrder,
            );
            if (updated) {
              if (
                !isValidTeacherProfileId ||
                updated.teacherprofileID === this.$route.params.teacherProfileId
              ) {
                const currentItems = this.syncedProductOrderModels || [];
                const index = currentItems.findIndex(
                  (i) => i.id === updated.id,
                );
                if (index !== -1) {
                  currentItems[index] = updated;
                  const newItems = [...currentItems];
                  this.handleProductOrdersUpdate(newItems);
                } else if (index === -1) {
                  // If new to this view
                  currentItems.push(updated);
                  const newItems = [...currentItems];
                  this.handleProductOrdersUpdate(newItems);
                }
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.productOrdersSubDelete = API.graphql({
          query: onDeleteTeacherProductsOrder,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const deleted = value.data.onDeleteTeacherProductsOrder;
            if (deleted) {
              if (
                !isValidTeacherProfileId ||
                deleted.teacherprofileID === this.$route.params.teacherProfileId
              ) {
                const currentItems = this.syncedProductOrderModels || [];
                const newItems = currentItems.filter(
                  (i) => i.id !== deleted.id,
                );
                this.handleProductOrdersUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncProducts() {
      try {
        // console.log("syncProducts");
        let items = await this.fetchAll(listProducts, "listProducts");

        for (let item of items) {
          if (!item || !item.id) {
            console.warn("syncProducts - Skipping invalid item:", item);
            continue;
          }
        }

        this.handleProductsUpdate(items);

        this.productsSubCreate = API.graphql({
          query: onCreateProduct,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const created = this.parseGraphqlResult(value.data.onCreateProduct);
            if (created) {
              const currentItems = this.syncedProductModels || [];
              const newItems = [...currentItems, created];
              this.handleProductsUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });

        this.productsSubUpdate = API.graphql({
          query: onUpdateProduct,
          variables: { filter: { _deleted: { ne: true } } },
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const updated = this.parseGraphqlResult(value.data.onUpdateProduct);
            if (updated) {
              const currentItems = this.syncedProductModels || [];
              const index = currentItems.findIndex((i) => i.id === updated.id);
              if (index !== -1) {
                currentItems[index] = updated;
                const newItems = [...currentItems];
                this.handleProductsUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.productsSubDelete = API.graphql({
          query: onDeleteProduct,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const deleted = value.data.onDeleteProduct;
            if (deleted) {
              const currentItems = this.syncedProductModels || [];
              const newItems = currentItems.filter((i) => i.id !== deleted.id);
              this.handleProductsUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncProductBundles() {
      try {
        let items = await this.fetchAll(
          listProductBundles,
          "listProductBundles",
        );

        for (let item of items) {
          if (!item || !item.id) {
            console.warn("syncProductBundles - Skipping invalid item:", item);
            continue;
          }
        }

        this.handleProductBundlesUpdate(items);

        this.productBundlesSubCreate = API.graphql({
          query: onCreateProductBundle,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const created = this.parseGraphqlResult(
              value.data.onCreateProductBundle,
            );
            if (created) {
              const currentItems = this.syncedProductBundleModels || [];
              const newItems = [...currentItems, created];
              this.handleProductBundlesUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });

        this.productBundlesSubUpdate = API.graphql({
          query: onUpdateProductBundle,
          variables: { filter: { _deleted: { ne: true } } },
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const updated = this.parseGraphqlResult(
              value.data.onUpdateProductBundle,
            );
            if (updated) {
              const currentItems = this.syncedProductBundleModels || [];
              const index = currentItems.findIndex((i) => i.id === updated.id);
              if (index !== -1) {
                currentItems[index] = updated;
                const newItems = [...currentItems];
                this.handleProductBundlesUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.productBundlesSubDelete = API.graphql({
          query: onDeleteProductBundle,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const deleted = value.data.onDeleteProductBundle;
            if (deleted) {
              const currentItems = this.syncedProductBundleModels || [];
              const newItems = currentItems.filter((i) => i.id !== deleted.id);
              this.handleProductBundlesUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncSecrets() {
      try {
        let items = await this.fetchAll(listSecrets, "listSecrets");

        for (let item of items) {
          if (!item || !item.id) {
            console.warn("syncSecrets - Skipping invalid item:", item);
            continue;
          }
        }

        this.handleSecretsUpdate(items);

        this.secretsSubCreate = API.graphql({
          query: onCreateSecret,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const created = this.parseGraphqlResult(value.data.onCreateSecret);
            if (created) {
              const currentItems = this.syncedSecretArray || [];
              const newItems = [...currentItems, created];
              this.handleSecretsUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });

        this.secretsSubUpdate = API.graphql({
          query: onUpdateSecret,
          variables: { filter: { _deleted: { ne: true } } },
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const updated = this.parseGraphqlResult(value.data.onUpdateSecret);
            if (updated) {
              const currentItems = this.syncedSecretArray || [];
              const index = currentItems.findIndex((i) => i.id === updated.id);
              if (index !== -1) {
                currentItems[index] = updated;
                const newItems = [...currentItems];
                this.handleSecretsUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.secretsSubDelete = API.graphql({
          query: onDeleteSecret,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const deleted = value.data.onDeleteSecret;
            if (deleted) {
              const currentItems = this.syncedSecretArray || [];
              const newItems = currentItems.filter((i) => i.id !== deleted.id);
              this.handleSecretsUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });
      } catch (error) {
        console.log(error);
      }
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    },

    calculateOrderTotal(item) {
      if (!item || !item.orderProducts) return 0;
      let orderTotal = 0;

      //calculate NonPhysicalProductsPrice
      const nonPhysicalProducts = item.orderProducts.filter(
        (product) => !product.physical || product.physical === false,
      );
      const nonPhysicalProductsPrice = nonPhysicalProducts.reduce(
        (total, product) => {
          const price = product.price || 0;
          const discount = product.discountPercentage || 0;
          return total + price * (1 - discount / 100);
        },
        0,
      );

      //calculate PhysicalProductsPrice
      const physicalProducts = item.orderProducts.filter(
        (product) => product.physical === true,
      );
      const physicalProductsPrice = physicalProducts.reduce(
        (total, product) => {
          const price = product.price || 0;
          const discount = product.discountPercentage || 0;
          return total + price * (1 - discount / 100);
        },
        0,
      );

      //calculate AddonsTotal

      // Previous code - did not account for addons being null or undefined, or not being an array
      //const addonsTotal = item.orderProducts.reduce((total, product) => {
      //   return (
      //     total +
      //     (product.addons
      //       ? product.addons.reduce((sum, addon) => sum + (addon.price || 0), 0)
      //       : 0)
      //   );
      // }, 0);

      const addonsTotal = item.orderProducts.reduce((total, product) => {
        const addons = Array.isArray(product.addons) ? product.addons : [];
        return (
          total + addons.reduce((sum, addon) => sum + (addon?.price || 0), 0)
        );
      }, 0);

      orderTotal =
        nonPhysicalProductsPrice +
        physicalProductsPrice +
        addonsTotal +
        (item.orderProducts.some((product) => product.physical === true)
          ? 130.0
          : 0);

      //calculate coupon discount if applicable
      let discount = 0;
      if (item.coupon) {
        if (item.coupon.discount.type === "PERCENTAGE") {
          discount = orderTotal * (item.coupon.discount.value / 100);
        } else {
          discount = item.coupon.discount.value;
        }
      }
      orderTotal = orderTotal - discount;

      // console.log(
      //   `${
      //     item.orderID
      //   }: ${orderTotal} = ${nonPhysicalProductsPrice} (non-physical) + ${physicalProductsPrice} (physical) + ${addonsTotal} (addons) + ${
      //     item.orderProducts.some((product) => product.physical === true)
      //       ? 130.0
      //       : 0
      //   } (shipping) - ${discount} (coupon discount)`
      // );

      return parseFloat(orderTotal.toFixed(2));
    },

    resetForm() {
      if (this.$refs.form) this.$refs.form.reset();

      this.editedItem = _.cloneDeep(this.defaultItem);
      this.shippingDetails = _.cloneDeep(this.defaultShippingDetails);
      this.editedIndex = -1;
      // this.validCoupon = null;
      this.newNote = "";
      this.couponCode = "";
      this.couponVerifyErrors = [];
      this.verifyingCoupon = false;
      this.valid = false;
      this.validCreate = false;
    },

    createItem() {
      // this.resetForm();

      this.editedItem.owner = this.decodedRouteParamOwner;
      this.editedItem.teacherprofileID = this.$route.params.teacherProfileId;
      this.editedItem.orderPaymentMethod = "EFT";
      this.createDialog = true;
    },

    viewItem(item) {
      this.editedItem = _.cloneDeep(item); //Object.assign({}, item);

      if (item.orderShippingDetails) {
        this.shippingDetails = _.cloneDeep(item.orderShippingDetails);
        this.syncedShippingDetails = _.cloneDeep(item.orderShippingDetails);
      } else {
        this.shippingDetails = _.cloneDeep(this.defaultShippingDetails); //Object.assign({}, this.defaultShippingDetails);
        this.syncedShippingDetails = null;
      }

      console.log("viewItem", this.editedItem);

      this.dialog = true;
    },

    editItem(item) {
      this.resetForm();
      this.editedIndex = this.productOrderModels.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.editedItem = _.cloneDeep(item);

      if (item.orderShippingDetails) {
        this.shippingDetails = _.cloneDeep(item.orderShippingDetails);
        this.syncedShippingDetails = _.cloneDeep(item.orderShippingDetails);
      } else {
        this.shippingDetails = _.cloneDeep(this.defaultShippingDetails);
        this.syncedShippingDetails = null;
      }

      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.createDialog = false;
      this.$nextTick(() => {
        this.resetForm();
      });
    },

    // Price after product discount + recommended discount (addons: full price,
    // matching how calculateOrderTotal treats them)
    preCouponPrice(line, isAddon = false) {
      let price = line.price || 0;
      if (!isAddon) {
        if (line.discountPercentage) {
          price *= 1 - line.discountPercentage / 100;
        }
        if (line.recommendedDiscountPercentage) {
          // TODO: rename to your actual field
          price *= 1 - line.recommendedDiscountPercentage / 100;
        }
      }
      return Math.max(price, 0);
    },

    discountedPrice(line, isAddon = false) {
      let price = this.preCouponPrice(line, isAddon);

      const coupon = this.editedItem.coupon;
      if (coupon && coupon.discount) {
        if (coupon.discount.type === "PERCENTAGE") {
          price *= 1 - coupon.discount.value / 100;
        } else if (this.preCouponLinesTotal > 0) {
          // Fixed-amount coupon: this line absorbs its proportional share
          const share = price / this.preCouponLinesTotal;
          price -= coupon.discount.value * share;
        }
      }
      return Math.max(price, 0);
    },
  },

  beforeDestroy() {
    if (this.productOrdersSubCreate) this.productOrdersSubCreate.unsubscribe();
    if (this.productOrdersSubUpdate) this.productOrdersSubUpdate.unsubscribe();
    if (this.productOrdersSubDelete) this.productOrdersSubDelete.unsubscribe();
    if (this.productsSubCreate) this.productsSubCreate.unsubscribe();
    if (this.productsSubUpdate) this.productsSubUpdate.unsubscribe();
    if (this.productsSubDelete) this.productsSubDelete.unsubscribe();
    if (this.productBundlesSubCreate)
      this.productBundlesSubCreate.unsubscribe();
    if (this.productBundlesSubUpdate)
      this.productBundlesSubUpdate.unsubscribe();
    if (this.productBundlesSubDelete)
      this.productBundlesSubDelete.unsubscribe();
    if (this.secretsSubCreate) this.secretsSubCreate.unsubscribe();
    if (this.secretsSubUpdate) this.secretsSubUpdate.unsubscribe();
    if (this.secretsSubDelete) this.secretsSubDelete.unsubscribe();
  },
};
</script>
